var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1985.81 1455.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8e6da;}.cls-2{isolation:isolate;}.cls-3,.cls-46{fill:#0084ff;}.cls-3{opacity:0.1;}.cls-34,.cls-4{fill:#0084e8;}.cls-5{fill:#fff;}.cls-6{fill:#e60022;}.cls-7{fill:#2b2b3a;}.cls-8{fill:#b7c5d4;}.cls-9{fill:#e6f1f7;}.cls-10{fill:#ebf2f7;}.cls-11{fill:#404259;}.cls-12{fill:#8699b0;}.cls-13{fill:#adbcd1;}.cls-14{opacity:0.4;}.cls-15{fill:#c8c9ca;}.cls-16{fill:#42baf9;}.cls-17{fill:#eb9c00;}.cls-18{mix-blend-mode:multiply;}.cls-19{fill:#d8e7f0;}.cls-20{fill:#00ab49;}.cls-21{clip-path:url(#clip-path);}.cls-22{fill:none;}.cls-23{fill:#f5dcc1;}.cls-24{fill:#869fba;}.cls-25{fill:#617482;}.cls-26{clip-path:url(#clip-path-2);}.cls-27{fill:#e48c82;}.cls-28{fill:#bf635f;}.cls-29{fill:#21202b;}.cls-30{fill:#c25353;}.cls-31{fill:#491909;}.cls-32{fill:#5e90c2;}.cls-33{fill:#ca6d6d;}.cls-34{opacity:0.8;}.cls-35{fill:#6859de;}.cls-36{fill:#da565d;}.cls-37{fill:#cacae0;}.cls-38{fill:#a5b4c7;}.cls-39{fill:#2a3a49;}.cls-40{fill:#394b61;}.cls-41{fill:#cc6c67;}.cls-42{fill:#6c3231;}.cls-43{opacity:0.25;}.cls-44{fill:#bb5151;}.cls-45{fill:#a35e5b;}.cls-47{fill:#763e3e;}.cls-48{fill:#f1cb89;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-7.1 -21.58)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1402.93,
    cy: 1056.3,
    r: 45.12,
    transform: "translate(-109.84 1948.21) rotate(-67.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-7.1 -21.58)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1581.09,
    cy: 1057.07,
    r: 45.12,
    transform: "translate(-0.57 2113.28) rotate(-67.5)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1321.68,21.58a658,658,0,0,0-311.26,77.87C885.43,166.28,747.69,206.26,606,209q-6.57.14-13.16.4C277.73,222.23,21.33,477.77,7.69,792.83c-15.15,349.85,264,638.24,610.49,638.24,69.26,0,133.54-11.55,193.26-32.82,119.07-42.39,247.61-47.1,371.5-22.09a704.12,704.12,0,0,0,138.74,14c370.71,0,671.23-306.37,671.23-684.29S1692.39,21.58,1321.68,21.58Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1846.08,1477.56H172.78a15.37,15.37,0,0,1-15.32-15.32h0a15.37,15.37,0,0,1,15.32-15.32h1673.3a15.36,15.36,0,0,1,15.32,15.32h0A15.37,15.37,0,0,1,1846.08,1477.56Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 268.56,
    y: 398.72,
    width: 240.12,
    height: 97.41,
    rx: 12.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M317.48,493.4c-2.52,0-4.56-1.52-4.56-3.39V445.47c0-1.86,2-3.38,4.56-3.38s4.56,1.52,4.56,3.38V490C322,491.88,320,493.4,317.48,493.4Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M297.7,463.52a5.73,5.73,0,0,1-2.57-.59c-2.08-1.06-2.61-3.17-1.19-4.71l19.78-21.42a5.11,5.11,0,0,1,3.74-1.47h0a5.17,5.17,0,0,1,3.75,1.45l19,20.3c1.44,1.53.92,3.64-1.14,4.7a5.59,5.59,0,0,1-6.35-.85l-15.24-16.26-16,17.37A5.19,5.19,0,0,1,297.7,463.52Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M363.93,482.71h-15.6v-6.37l14.58-22.2h8.28v22.2h4.6v6.37h-4.6v7.16h-7.26Zm0-18.68h-.11l-7.91,12.31h8Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M381.59,481.69h7.27l-4.54,14.23h-6.46Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M411.47,461.1H393.8v-7h26.14v6.66l-14.28,29.07h-8.82Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M423.49,472a36.87,36.87,0,0,1,.58-6.47,18.49,18.49,0,0,1,2.07-6,12.29,12.29,0,0,1,4.05-4.37,13.65,13.65,0,0,1,13.12,0,12.35,12.35,0,0,1,4.07,4.37,19,19,0,0,1,2.07,6,36.32,36.32,0,0,1,0,12.93,19.16,19.16,0,0,1-2.07,5.95,12.24,12.24,0,0,1-4.07,4.36,13.51,13.51,0,0,1-13.12,0,12.18,12.18,0,0,1-4.05-4.36,18.66,18.66,0,0,1-2.07-5.95A36.84,36.84,0,0,1,423.49,472Zm7.56,0c0,.94.05,2.07.14,3.37a15.75,15.75,0,0,0,.67,3.79,7.89,7.89,0,0,0,1.7,3.08,4.05,4.05,0,0,0,3.19,1.27,4.13,4.13,0,0,0,3.19-1.27,7.91,7.91,0,0,0,1.71-3.08,16.27,16.27,0,0,0,.68-3.79c.09-1.3.13-2.43.13-3.37s0-2.07-.13-3.39a16.28,16.28,0,0,0-.68-3.78,7.91,7.91,0,0,0-1.71-3.08,4.12,4.12,0,0,0-3.19-1.26,4,4,0,0,0-3.19,1.26,7.89,7.89,0,0,0-1.7,3.08,15.76,15.76,0,0,0-.67,3.78C431.1,469.94,431.05,471.06,431.05,472Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M483.19,453.54a24.06,24.06,0,0,1,5.65.7,13.19,13.19,0,0,1,5.15,2.47l-4.84,5.91a7.46,7.46,0,0,0-2.78-1.54,13.91,13.91,0,0,0-3.18-.58v8l4.84,1.42a10.94,10.94,0,0,1,5.33,3.3,8.56,8.56,0,0,1,2,5.83,10.94,10.94,0,0,1-1,4.69,10.39,10.39,0,0,1-2.63,3.44,12.53,12.53,0,0,1-3.88,2.21,19.15,19.15,0,0,1-4.7,1.07V494h-3.33v-3.53a25.18,25.18,0,0,1-6.64-.91,14.3,14.3,0,0,1-5.82-3.18l5.35-6a7.19,7.19,0,0,0,3.17,2.3,15,15,0,0,0,3.94.84V475l-3.69-1.11a13,13,0,0,1-5.82-3.4,8.63,8.63,0,0,1-2-6,9.42,9.42,0,0,1,1-4.28,10.18,10.18,0,0,1,2.55-3.28,13.7,13.7,0,0,1,3.68-2.23,15.78,15.78,0,0,1,4.32-1.1V450h3.33Zm-3.33,7.11a7,7,0,0,0-2.53,1.06,2.67,2.67,0,0,0-1.11,2.37,3.2,3.2,0,0,0,.46,1.82,3.84,3.84,0,0,0,1.05,1,4.27,4.27,0,0,0,1.22.52l.91.25Zm3.33,22.76a10.49,10.49,0,0,0,1.54-.43,5.25,5.25,0,0,0,1.39-.73,4,4,0,0,0,1-1.08,2.87,2.87,0,0,0,.38-1.49,3,3,0,0,0-.28-1.37,2.8,2.8,0,0,0-.73-.93,4.41,4.41,0,0,0-1.06-.65c-.4-.2-.83-.37-1.26-.54l-1-.35Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "407.87 494.43 380.69 539.74 350.68 492.17 407.87 494.43"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1340.66,
    y: 191.78,
    width: 251.22,
    height: 101.91,
    rx: 13.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1390.72,229.08c2.64,0,4.78,1.58,4.78,3.54v46.6c0,1.95-2.14,3.53-4.78,3.53s-4.77-1.58-4.77-3.53v-46.6C1386,230.66,1388.09,229.08,1390.72,229.08Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1411.42,260.34a6,6,0,0,1,2.69.62c2.18,1.1,2.73,3.31,1.24,4.92l-20.68,22.41a5.4,5.4,0,0,1-3.93,1.54h0a5.41,5.41,0,0,1-3.93-1.52l-19.89-21.23c-1.5-1.61-1-3.81,1.2-4.93a5.88,5.88,0,0,1,6.64.89l15.94,17,16.78-18.18A5.42,5.42,0,0,1,1411.42,260.34Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1440.12,278.65h-16.33V272l15.26-23.23h8.66V272h4.81v6.66h-4.81v7.49h-7.59Zm0-19.54H1440L1431.72,272h8.4Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1458.59,277.58h7.61l-4.75,14.9h-6.76Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1489.85,256.05h-18.48v-7.29h27.35v7l-14.94,30.41h-9.24Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1502.43,267.45a38.35,38.35,0,0,1,.61-6.76,19.33,19.33,0,0,1,2.16-6.23,12.9,12.9,0,0,1,4.24-4.57,14.27,14.27,0,0,1,13.73,0,12.83,12.83,0,0,1,4.25,4.57,19.83,19.83,0,0,1,2.17,6.23,37.82,37.82,0,0,1,0,13.53,20.1,20.1,0,0,1-2.17,6.23,12.69,12.69,0,0,1-4.25,4.55,14.13,14.13,0,0,1-13.73,0,12.75,12.75,0,0,1-4.24-4.55,19.58,19.58,0,0,1-2.16-6.23A38.46,38.46,0,0,1,1502.43,267.45Zm7.91,0c0,1,.05,2.17.14,3.54a16.68,16.68,0,0,0,.71,4,8.32,8.32,0,0,0,1.77,3.22,4.86,4.86,0,0,0,6.68,0,8.23,8.23,0,0,0,1.79-3.22,17.75,17.75,0,0,0,.71-4c.09-1.37.14-2.55.14-3.54s0-2.16-.14-3.54a17.66,17.66,0,0,0-.71-4,8.34,8.34,0,0,0-1.79-3.23,4.34,4.34,0,0,0-3.33-1.32,4.29,4.29,0,0,0-3.35,1.32,8.44,8.44,0,0,0-1.77,3.23,16.6,16.6,0,0,0-.71,4C1510.39,265.29,1510.34,266.47,1510.34,267.45Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1564.89,248.13a24.86,24.86,0,0,1,5.92.74,13.73,13.73,0,0,1,5.38,2.58l-5.07,6.18a7.81,7.81,0,0,0-2.9-1.61,15.25,15.25,0,0,0-3.33-.61v8.4l5.07,1.48a11.52,11.52,0,0,1,5.57,3.46,9,9,0,0,1,2.09,6.1,11.43,11.43,0,0,1-1,4.9,10.77,10.77,0,0,1-2.75,3.6,13.1,13.1,0,0,1-4.07,2.31,20.3,20.3,0,0,1-4.91,1.12v3.69h-3.48v-3.69a26.22,26.22,0,0,1-7-.95,15,15,0,0,1-6.09-3.33l5.59-6.28a7.68,7.68,0,0,0,3.32,2.4,16.16,16.16,0,0,0,4.13.88v-8.93l-3.86-1.17a13.44,13.44,0,0,1-6.09-3.55,9,9,0,0,1-2.09-6.32,9.81,9.81,0,0,1,1-4.48,10.77,10.77,0,0,1,2.67-3.44,14.23,14.23,0,0,1,3.85-2.33,16.88,16.88,0,0,1,4.52-1.15v-3.7h3.48Zm-3.48,7.45a7.19,7.19,0,0,0-2.65,1.1,2.8,2.8,0,0,0-1.16,2.48,3.28,3.28,0,0,0,.48,1.9,3.93,3.93,0,0,0,1.1,1.09,4.39,4.39,0,0,0,1.28.54l1,.27Zm3.48,23.8a11.4,11.4,0,0,0,1.61-.44,5.8,5.8,0,0,0,1.46-.77,4.21,4.21,0,0,0,1-1.13,2.92,2.92,0,0,0,.39-1.56,3,3,0,0,0-.29-1.43,2.81,2.81,0,0,0-.76-1,4.36,4.36,0,0,0-1.11-.69c-.42-.2-.86-.38-1.32-.55l-1-.37Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1486.42 291.92 1457.98 339.32 1426.58 289.55 1486.42 291.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M173.71,648.81a6,6,0,0,1-6-6V423.78a6,6,0,0,1,11.91,0V642.85A6,6,0,0,1,173.71,648.81Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 147.75,
    y: 418.65,
    width: 36.75,
    height: 176.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M653.93,595.13a6,6,0,0,1-5.95-6V370.1a5.95,5.95,0,0,1,11.9,0V589.17A6,6,0,0,1,653.93,595.13Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 627.97,
    y: 364.97,
    width: 36.75,
    height: 176.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M880.26,602.86a6,6,0,0,1-6-6V377.84a6,6,0,1,1,11.91,0V596.91A6,6,0,0,1,880.26,602.86Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 854.29,
    y: 372.7,
    width: 36.75,
    height: 176.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1108.52,1026.5a6,6,0,0,1-6-6V801.47a6,6,0,0,1,11.91,0v219.07A6,6,0,0,1,1108.52,1026.5Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1082.55,
    y: 796.34,
    width: 36.75,
    height: 176.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1414.15,759.55a6,6,0,0,1-6-5.95V534.53a6,6,0,1,1,11.91,0V753.6A6,6,0,0,1,1414.15,759.55Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1388.19,
    y: 529.39,
    width: 36.75,
    height: 176.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1468.32,622.21a6,6,0,0,1-6-6V397.18a6,6,0,0,1,11.91,0V616.25A6,6,0,0,1,1468.32,622.21Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1442.35,
    y: 392.05,
    width: 36.75,
    height: 176.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1692.71,523.55a6,6,0,0,1-6-5.95V298.53a6,6,0,1,1,11.91,0V517.6A6,6,0,0,1,1692.71,523.55Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1666.75,
    y: 293.39,
    width: 36.75,
    height: 176.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M228.36,707.32a6,6,0,0,1-6-6V566a5.95,5.95,0,1,1,11.9,0V701.37A6,6,0,0,1,228.36,707.32Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 202.88,
    y: 559.86,
    width: 36.75,
    height: 98.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M547.54,766.8a6,6,0,0,1-6-5.95V625.44a6,6,0,0,1,11.91,0V760.85A6,6,0,0,1,547.54,766.8Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 522.06,
    y: 619.34,
    width: 36.75,
    height: 98.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M712,629.46a6,6,0,0,1-6-6V488.1a6,6,0,0,1,11.91,0V623.51A6,6,0,0,1,712,629.46Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 686.48,
    y: 482,
    width: 36.75,
    height: 98.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M936.35,698.62a6,6,0,0,1-6-6V557.25a6,6,0,0,1,11.91,0V692.66A6,6,0,0,1,936.35,698.62Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 910.88,
    y: 551.15,
    width: 36.75,
    height: 98.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M994.39,772.12a6,6,0,0,1-6-6V630.76a6,6,0,0,1,11.91,0V766.17A6,6,0,0,1,994.39,772.12Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 968.91,
    y: 624.66,
    width: 36.75,
    height: 98.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1520.54,675.4a6,6,0,0,1-6-5.95V534a6,6,0,0,1,11.91,0V669.45A6,6,0,0,1,1520.54,675.4Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1495.07,
    y: 527.94,
    width: 36.75,
    height: 98.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1866.81,627a6,6,0,0,1-6-5.95V485.68a6,6,0,0,1,11.91,0V621.09A6,6,0,0,1,1866.81,627Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1841.33,
    y: 479.58,
    width: 36.75,
    height: 98.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1754.61,607.7a6,6,0,0,1-5.95-6V466.34a6,6,0,1,1,11.9,0V601.75A6,6,0,0,1,1754.61,607.7Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1729.13,
    y: 460.24,
    width: 36.75,
    height: 98.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1213,797.27a6,6,0,0,1-6-5.95V655.91a6,6,0,0,1,11.91,0V791.32A6,6,0,0,1,1213,797.27Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1187.5,
    y: 649.81,
    width: 36.75,
    height: 98.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1054.35,859.17a6,6,0,0,1-5.95-5.95V717.81a6,6,0,0,1,11.91,0V853.22A6,6,0,0,1,1054.35,859.17Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1028.87,
    y: 711.71,
    width: 36.75,
    height: 98.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M279.14,745.53a6,6,0,0,1-5.95-6V639a5.95,5.95,0,0,1,11.9,0V739.57A6,6,0,0,1,279.14,745.53Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 255.11,
    y: 631.43,
    width: 34.82,
    height: 69.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M441.63,786.15a6,6,0,0,1-5.95-6V679.61a6,6,0,1,1,11.9,0V780.19A6,6,0,0,1,441.63,786.15Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 417.6,
    y: 672.05,
    width: 34.82,
    height: 69.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M495.31,844.18a6,6,0,0,1-5.95-5.95V737.64a6,6,0,1,1,11.9,0V838.23A6,6,0,0,1,495.31,844.18Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.28,
    y: 730.09,
    width: 34.82,
    height: 69.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1269.07,836.44a6,6,0,0,1-6-6V729.9a6,6,0,0,1,11.91,0V830.49A6,6,0,0,1,1269.07,836.44Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1245.05,
    y: 722.35,
    width: 34.82,
    height: 69.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M766.61,699.1a6,6,0,0,1-6-6V592.56a6,6,0,1,1,11.9,0V693.15A6,6,0,0,1,766.61,699.1Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 742.58,
    y: 585.01,
    width: 34.82,
    height: 69.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M332.82,794.12a5.22,5.22,0,0,1-5.22-5.22V711.52a5.22,5.22,0,0,1,10.44,0V788.9A5.22,5.22,0,0,1,332.82,794.12Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 308.79,
    y: 700.74,
    width: 34.82,
    height: 53.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1315.5,885a5.22,5.22,0,0,1-5.22-5.22V802.44a5.22,5.22,0,0,1,10.44,0v77.38A5.22,5.22,0,0,1,1315.5,885Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1291.47,
    y: 791.65,
    width: 34.82,
    height: 53.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1808.77,652.91a5.22,5.22,0,0,1-5.22-5.22V570.31a5.22,5.22,0,0,1,10.44,0v77.38A5.22,5.22,0,0,1,1808.77,652.91Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1784.75,
    y: 559.52,
    width: 34.82,
    height: 53.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1576.16,595.51a5.22,5.22,0,0,1-5.22-5.22V512.91a5.22,5.22,0,1,1,10.44,0v77.38A5.22,5.22,0,0,1,1576.16,595.51Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1552.13,
    y: 502.12,
    width: 34.82,
    height: 53.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M388,760a6,6,0,0,1-5.95-5.95V613.35a5.95,5.95,0,1,1,11.9,0V754.08A6,6,0,0,1,388,760Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 363.92,
    y: 611.4,
    width: 34.82,
    height: 97.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M601.22,669a6,6,0,0,1-6-6V522.29a6,6,0,0,1,11.91,0V663A6,6,0,0,1,601.22,669Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 577.19,
    y: 520.33,
    width: 34.82,
    height: 97.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M818.84,645.76a6,6,0,0,1-6-6V499.08a6,6,0,1,1,11.9,0V639.8A6,6,0,0,1,818.84,645.76Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 794.81,
    y: 497.12,
    width: 34.82,
    height: 97.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1157.36,881.76a6,6,0,0,1-5.95-6V735.07a6,6,0,1,1,11.9,0V875.8A6,6,0,0,1,1157.36,881.76Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1133.33,
    y: 733.12,
    width: 34.82,
    height: 97.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1366.28,846.94a6,6,0,0,1-6-6V700.25a6,6,0,0,1,11.91,0V841A6,6,0,0,1,1366.28,846.94Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1342.25,
    y: 698.3,
    width: 34.82,
    height: 97.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1631.29,566.45a6,6,0,0,1-6-6V419.76a6,6,0,0,1,11.9,0V560.49A6,6,0,0,1,1631.29,566.45Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1607.26,
    y: 417.81,
    width: 34.82,
    height: 97.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1915.65,562.58a6,6,0,0,1-6-6V415.9a6,6,0,1,1,11.9,0V556.62A6,6,0,0,1,1915.65,562.58Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1891.62,
    y: 413.94,
    width: 34.82,
    height: 97.43
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1252.47 618.12 1252.47 1172.54 1705.42 1172.54 1705.42 701.95 1605.7 618.12 1252.47 618.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1705.42 701.95 1612.77 707.83 1605.7 618.12 1705.42 701.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1543.4,742.89H1404.18a5.9,5.9,0,0,1-5.88-5.89h0a5.9,5.9,0,0,1,5.88-5.88H1543.4a5.9,5.9,0,0,1,5.88,5.88h0A5.9,5.9,0,0,1,1543.4,742.89Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1391.2,
    y: 670.57,
    width: 150.98,
    height: 11.76,
    rx: 5.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1666.93,893.62H1299a5.9,5.9,0,0,1-5.88-5.88h0a5.9,5.9,0,0,1,5.88-5.88h367.9a5.9,5.9,0,0,1,5.89,5.88h0A5.9,5.9,0,0,1,1666.93,893.62Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1666.93,926.71H1299a5.9,5.9,0,0,1-5.88-5.88h0A5.9,5.9,0,0,1,1299,915h367.9a5.9,5.9,0,0,1,5.89,5.88h0A5.9,5.9,0,0,1,1666.93,926.71Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1666.93,965.68H1299a5.9,5.9,0,0,1-5.88-5.88h0a5.9,5.9,0,0,1,5.88-5.88h367.9a5.9,5.9,0,0,1,5.89,5.88h0A5.9,5.9,0,0,1,1666.93,965.68Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1666.93,1136.94H1299a5.9,5.9,0,0,1-5.88-5.88h0a5.9,5.9,0,0,1,5.88-5.88h367.9a5.9,5.9,0,0,1,5.89,5.88h0A5.9,5.9,0,0,1,1666.93,1136.94Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1111.09,1326s14.65,72.06,0,112.36l312.66,1.28,0-114.8Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1406,1324.5s-21.37,29.61-21.38,60.76,26.55,56.49,26.55,56.49Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1394.65 1408.27 1394.67 1310.56 1091.78 1310.49 1091.78 1293.4 1765.96 1293.53 1765.93 1425.44 1091.76 1425.3 1091.76 1408.2 1394.65 1408.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1457,1381.15a25.8,25.8,0,1,1,25.79,25.8A25.81,25.81,0,0,1,1457,1381.15Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1500.38,1381.16c0-11.35-9.4-20.71-21.67-22.46a29.2,29.2,0,0,1,4.11-.37c14.26,0,25.8,10.23,25.8,22.83s-11.55,22.82-25.81,22.82a27.78,27.78,0,0,1-4.11-.37C1491,1401.86,1500.38,1392.51,1500.38,1381.16Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1453.36,1381.15a29.46,29.46,0,1,1,29.45,29.47A29.5,29.5,0,0,1,1453.36,1381.15Zm7.33,0a22.14,22.14,0,1,0,22.13-22.13A22.16,22.16,0,0,0,1460.69,1381.15Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1458.7,1374.9a1.82,1.82,0,0,0,1.72-1.23,23.27,23.27,0,0,1,21.44-16,1.74,1.74,0,0,0,1.88-1.78A1.82,1.82,0,0,0,1482,1354a26.85,26.85,0,0,0-25,18.47,1.83,1.83,0,0,0,1.11,2.34A1.87,1.87,0,0,0,1458.7,1374.9Z",
    transform: "translate(-7.1 -21.58)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1554.95,
    y: 1329.69,
    width: 167.17,
    height: 57.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1658.46,
    y: 1329.7,
    width: 64.12,
    height: 57.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1581,1370.94l64.19,0a1.81,1.81,0,0,0,1.8-1.8v-.52a1.81,1.81,0,0,0-1.8-1.8H1581a1.79,1.79,0,0,0-1.79,1.79v.53A1.79,1.79,0,0,0,1581,1370.94Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1581,1379.19h64.19a1.8,1.8,0,0,0,1.8-1.79v-.53a1.81,1.81,0,0,0-1.8-1.8H1581a1.8,1.8,0,0,0-1.79,1.8v.52A1.8,1.8,0,0,0,1581,1379.19Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1606.75,1388.66h38.39a1.81,1.81,0,0,0,1.8-1.8v-.52a1.81,1.81,0,0,0-1.8-1.8h-38.39a1.81,1.81,0,0,0-1.8,1.8v.52A1.81,1.81,0,0,0,1606.75,1388.66Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1249.71,1373.63l-132.13,15.46c0-4.61-.07-9.19-.26-13.69Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1116.78,1406.53l251.08-4.48-252.57,16.22C1115.94,1414.46,1116.42,1410.53,1116.78,1406.53Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1116.42,1361.51c-.37-4.46-.81-8.69-1.27-12.63l201.43.95Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1707.6,1194.18s-14.65,72.06,0,112.36L1395,1307.82l0-114.8Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1412.65,1192.71s21.37,29.61,21.38,60.76-26.55,56.49-26.55,56.49Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1409.84 1276.47 1409.82 1178.77 1712.71 1178.7 1712.7 1161.61 1038.53 1161.74 1038.56 1293.65 1712.73 1293.51 1712.73 1276.41 1409.84 1276.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1361.67,1249.36a25.81,25.81,0,1,0-25.8,25.8A25.81,25.81,0,0,0,1361.67,1249.36Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1318.31,1249.37c0-11.36,9.4-20.71,21.67-22.46a29.34,29.34,0,0,0-4.12-.37c-14.25,0-25.8,10.23-25.8,22.83s11.56,22.82,25.81,22.82a27.92,27.92,0,0,0,4.12-.37C1327.72,1270.07,1318.31,1260.72,1318.31,1249.37Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1335.87,1278.83a29.47,29.47,0,1,1,29.46-29.47A29.51,29.51,0,0,1,1335.87,1278.83Zm0-51.6a22.14,22.14,0,1,0,22.14,22.13A22.16,22.16,0,0,0,1335.86,1227.23Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1360,1243.1a1.84,1.84,0,0,1-1.73-1.22,23.25,23.25,0,0,0-21.43-16,1.74,1.74,0,0,1-1.88-1.78,1.82,1.82,0,0,1,1.78-1.88,26.85,26.85,0,0,1,25,18.47,1.83,1.83,0,0,1-1.11,2.34A1.86,1.86,0,0,1,1360,1243.1Z",
    transform: "translate(-7.1 -21.58)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1082.36,
    y: 1197.9,
    width: 167.17,
    height: 57.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1081.91,
    y: 1197.91,
    width: 64.12,
    height: 57.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1237.73,1239.15l-64.18,0a1.81,1.81,0,0,1-1.8-1.8v-.52a1.81,1.81,0,0,1,1.8-1.8h64.18a1.8,1.8,0,0,1,1.8,1.79v.53A1.8,1.8,0,0,1,1237.73,1239.15Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1237.73,1247.4h-64.18a1.8,1.8,0,0,1-1.8-1.79v-.53a1.81,1.81,0,0,1,1.8-1.8h64.18a1.81,1.81,0,0,1,1.8,1.8v.52A1.81,1.81,0,0,1,1237.73,1247.4Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1211.94,1256.87h-38.39a1.81,1.81,0,0,1-1.8-1.8v-.52a1.81,1.81,0,0,1,1.8-1.81h38.38a1.81,1.81,0,0,1,1.81,1.8v.52A1.81,1.81,0,0,1,1211.94,1256.87Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1569,1241.84l132.13,15.46c0-4.61.07-9.19.26-13.69Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1701.91,1274.74l-251.08-4.48,252.57,16.22C1702.75,1282.67,1702.27,1278.74,1701.91,1274.74Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1702.27,1229.72c.37-4.46.81-8.69,1.27-12.63l-201.43,1Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1309.83,776.79a1.43,1.43,0,0,1-1.06-2.4l5.26-5.74a1.46,1.46,0,0,1,1.06-.46h0a1.43,1.43,0,0,1,1.06.47l4.78,5.25a1.44,1.44,0,1,1-2.12,1.94l-3.73-4.1-4.19,4.58A1.42,1.42,0,0,1,1309.83,776.79Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1532.13,858.54a1.44,1.44,0,0,1,2.41-1.06l5.73,5.26a1.42,1.42,0,0,1,.47,1.06h0a1.43,1.43,0,0,1-.47,1.06l-5.26,4.78a1.43,1.43,0,0,1-1.93-2.12l4.1-3.73-4.58-4.19A1.43,1.43,0,0,1,1532.13,858.54Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1527.59,798.78a1.47,1.47,0,0,1,.38-1,1.45,1.45,0,0,1,2-.09l5.73,5.26a1.43,1.43,0,0,1,.47,1.06h0a1.43,1.43,0,0,1-.47,1.06l-5.26,4.78a1.43,1.43,0,1,1-1.93-2.12l4.1-3.73-4.58-4.19A1.43,1.43,0,0,1,1527.59,798.78Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1526.64,784.68a1.43,1.43,0,0,1,2.4-1.06l5.74,5.26a1.44,1.44,0,0,1,.46,1.06h0a1.39,1.39,0,0,1-.47,1l-5.25,4.79a1.44,1.44,0,0,1-1.94-2.12l4.1-3.73-4.58-4.19A1.43,1.43,0,0,1,1526.64,784.68Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1371.5,863.08a.71.71,0,0,1-.71-.71V769.86a.72.72,0,1,1,1.43,0v92.51A.71.71,0,0,1,1371.5,863.08Z",
    transform: "translate(-7.1 -21.58)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1442.73,863.08a.71.71,0,0,1-.72-.71V769.86a.72.72,0,0,1,1.44,0v92.51A.71.71,0,0,1,1442.73,863.08Z",
    transform: "translate(-7.1 -21.58)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1518.74,863.08a.71.71,0,0,1-.71-.71V769.86a.72.72,0,1,1,1.43,0v92.51A.71.71,0,0,1,1518.74,863.08Z",
    transform: "translate(-7.1 -21.58)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1315.33,864.52a1.61,1.61,0,0,1-.53-.1,1.44,1.44,0,0,1-.81-1.86c1.18-3,29.12-73.1,55.84-73.1,8.89,0,16.86,10.55,26.1,22.76,11.79,15.61,25.17,33.29,43.46,33.29,15.86,0,29.35-13.37,43.64-27.52,14.63-14.5,29.76-29.49,48.15-29.49a1.44,1.44,0,0,1,0,2.87c-17.22,0-31.92,14.57-46.13,28.65s-28.62,28.36-45.66,28.36c-19.72,0-33.55-18.29-45.75-34.43-8.77-11.6-16.35-21.62-23.81-21.62-24.79,0-52.89,70.56-53.17,71.28A1.44,1.44,0,0,1,1315.33,864.52Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1315.69,865.23a1.46,1.46,0,0,1-.77-.22,1.42,1.42,0,0,1-.44-2c1-1.62,25.27-39.64,55.83-39.64,14,0,22.3,7.15,31.14,14.71,10.87,9.28,22,18.91,45.49,17.33,11.84-.79,24.29-12.34,37.48-24.57,15.11-14,30.74-28.5,47.47-28.5a1.43,1.43,0,1,1,0,2.86c-15.61,0-30.81,14.11-45.52,27.75-13.57,12.58-26.38,24.47-39.24,25.32-24.63,1.63-36.78-8.81-47.53-18-8.44-7.21-16.4-14-29.29-14-29,0-53.17,37.91-53.41,38.29A1.41,1.41,0,0,1,1315.69,865.23Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1315.09,864a1.31,1.31,0,0,1-.71-.21,1.33,1.33,0,0,1-.41-1.84c1.49-2.35,36.79-57.56,57.4-57.56,9.6,0,19.86,5.4,30.72,11.13,12.81,6.74,26.06,13.72,40.56,13.72,9.36,0,22.23-11.82,34.66-23.25,14.14-13,28.77-26.44,41.36-26.44a1.33,1.33,0,1,1,0,2.66c-11.55,0-25.79,13.08-39.56,25.74-13.4,12.32-26,23.95-36.46,23.95-15.15,0-29.31-7.45-41.8-14-10.56-5.56-20.54-10.82-29.48-10.82-19.16,0-54.8,55.77-55.16,56.33A1.32,1.32,0,0,1,1315.09,864Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1514.43,775.81a1.43,1.43,0,0,1,.38-1,1.45,1.45,0,0,1,2-.09l5.73,5.25a1.45,1.45,0,0,1,.47,1.06h0a1.42,1.42,0,0,1-.47,1.06l-5.26,4.79a1.43,1.43,0,0,1-1.93-2.12l4.1-3.73-4.58-4.19A1.46,1.46,0,0,1,1514.43,775.81Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1314.85,875a1.43,1.43,0,0,1-1.43-1.43V773.21a1.43,1.43,0,1,1,2.86,0V873.6A1.42,1.42,0,0,1,1314.85,875Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1537.15,865H1304.81a1.43,1.43,0,1,1,0-2.86h232.34a1.43,1.43,0,0,1,0,2.86Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1402.93,
    cy: 1056.3,
    r: 45.12,
    transform: "translate(-116.94 1926.64) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1395.98,
    cy: 1035.01,
    r: 45.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 1403.08,
    cy: 1056.3,
    r: 45.12,
    transform: "translate(-343.06 1279.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1404.4,1054.18l12-44.4s-62.16-6-60.73,46.7,53.57,48.12,58.73,47.84,30.3-13.33,34.09-20.92C1449.38,1081.69,1404.4,1054.18,1404.4,1054.18Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1404.4,1054.18l-38.1-39.24s-29.22,43.83-16.61,71,53.57,29.8,69.9,24.64Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1404.4,1054.18l-67.32,7.17s10.6,53.28,49.56,55.86Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1404.4,1054.18l-17.76,63s28.93,4.87,46.7-7.16,17.47-27.5,17.47-27.5Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1395.98,
    cy: 1035.01,
    r: 18.26
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1434.06,1032.35a1,1,0,0,1-.8-.43,1,1,0,0,1,.28-1.32l19.92-12.95a1,1,0,0,1,.52-.15h51.46a.95.95,0,1,1,0,1.9h-51.18l-19.68,12.79A.91.91,0,0,1,1434.06,1032.35Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1492.38,1001.25h-38.29a.95.95,0,0,1,0-1.9h38.29a.95.95,0,0,1,0,1.9Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1501.67,1011.66h-47.14a1,1,0,0,1,0-1.91h47.14a1,1,0,0,1,0,1.91Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1367.11,1036a1,1,0,0,1-.46-.12l-23.24-12.72h-52a.95.95,0,0,1,0-1.9h52.23a.93.93,0,0,1,.46.12l23.46,12.84a1,1,0,0,1,.38,1.29A1,1,0,0,1,1367.11,1036Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1333.91,1001.92h-43.38a.95.95,0,0,1,0-1.9h43.38a1,1,0,1,1,0,1.9Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1308.24,1013h-16.82a1,1,0,0,1,0-1.9h16.82a1,1,0,1,1,0,1.9Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1346.75,1089.12h-47.36a1,1,0,0,1,0-1.91h47.13l20.15-10.51a1,1,0,0,1,.88,1.69L1347.19,1089A1,1,0,0,1,1346.75,1089.12Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1326.39,1064.77h-28.33a1,1,0,0,1,0-1.9h28.33a1,1,0,1,1,0,1.9Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1333.91,1077.61H1298.5a1,1,0,1,1,0-1.9h35.41a1,1,0,1,1,0,1.9Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1581.09,
    cy: 1057.07,
    r: 45.12,
    transform: "translate(-7.67 2091.71) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 1574.13,
    cy: 1035.78,
    r: 45.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 1581.24,
    cy: 1057.07,
    r: 45.12,
    transform: "translate(-291.43 1406.13) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1582.56,1055l12-44.4s-62.16-6-60.73,46.69,53.57,48.13,58.73,47.85,30.29-13.33,34.09-20.92C1627.54,1082.45,1582.56,1055,1582.56,1055Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1582.56,1055l-67.32,7.16s10.6,53.29,49.56,55.87Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1582.56,1055l-17.76,63s28.93,4.87,46.69-7.16,17.48-27.51,17.48-27.51Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1581.24,
    cy: 1057.35,
    r: 18.26,
    transform: "translate(331.51 2475.97) rotate(-82.98)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1612.22,1033.12a.94.94,0,0,1-.8-.44,1,1,0,0,1,.28-1.31l19.92-12.95a.93.93,0,0,1,.52-.15h51.45a.95.95,0,1,1,0,1.9h-51.17L1612.74,1033A.91.91,0,0,1,1612.22,1033.12Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1670.54,1002h-38.29a.95.95,0,0,1,0-1.9h38.29a.95.95,0,1,1,0,1.9Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1679.83,1012.42h-47.14a.95.95,0,0,1,0-1.9h47.14a.95.95,0,1,1,0,1.9Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1524.91,1089.88h-47.36a1,1,0,1,1,0-1.9h47.13l20.15-10.51a.94.94,0,0,1,1.28.4,1,1,0,0,1-.4,1.28l-20.36,10.63A1,1,0,0,1,1524.91,1089.88Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1504.55,1065.54h-28.33a1,1,0,0,1,0-1.9h28.33a.95.95,0,0,1,0,1.9Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1512.07,1078.38h-35.41a1,1,0,0,1,0-1.91h35.41a1,1,0,0,1,0,1.91Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M959.08,1042.35,922.36,1080l-46.7-30.84-8.22,6.46s47.87,59.92,60.8,51.1,30.84-28.49,30.84-28.49Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M961.16,1037.78c-7.37-.42-14.13,11.33-15.59,15.14s-16.75,7.93-13.81,17.33l16.45,19.68s10,3.23,16.45-6.75S961.16,1037.78,961.16,1037.78Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M971.69,976.54c-.76,4.36.46,9.28-2,13a25.42,25.42,0,0,1-3.77,3.78,18.81,18.81,0,0,0-5.44,16.39c.62,3.71,2.37,7.22,2.45,11s-2.53,8.06-6.28,7.8a7.82,7.82,0,0,0,11.49-7.18,8,8,0,0,1-1.53,9.42,7,7,0,0,0,7-2.16,3.67,3.67,0,0,1-1.77,3.24,17.29,17.29,0,0,0,13.14-2.18,5.08,5.08,0,0,1-2.59,3.52l22.09,2.07a27.18,27.18,0,0,0,8.4-.09c2.75-.62,5.41-2.26,6.53-4.84a4.81,4.81,0,0,1-2.41,6.67,19.78,19.78,0,0,0,6.71-1.82,6.65,6.65,0,0,0,3.71-5.54,6.5,6.5,0,0,1-1.93,9.47,14.17,14.17,0,0,0,10.41-20.06c-1.75-3.66-5.06-6.6-5.89-10.57-1.14-5.46,2.75-11.46.32-16.48-1.17-2.44-3.63-4-5-6.41-1.6-2.84-1.36-6.35-2.39-9.44-1.08-3.26-3.51-5.87-5.86-8.37a10.54,10.54,0,0,0-3.46-2.75c-1.68-.7-3.59-.48-5.35-1a18.76,18.76,0,0,1-4-1.91c-4.64-2.49-10.68-3.29-15-.26-3.44,2.42-5.27,6.91-9.14,8.56-2.32,1-5.22.88-7,2.69A6.56,6.56,0,0,0,971.69,976.54Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "1013.43 1021.7 998.14 1013.41 999.64 987.04 983.09 986.6 978.05 1011.4 973.13 1013.7 954.53 1058.79 985.22 1068.68 1013.43 1021.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M985.48,1032.7l-24.32,5.08s-2.06,20.79-6.28,31.53a15.07,15.07,0,0,0,1.43,14.12,17.62,17.62,0,0,0,6.07,5.37l-1.9,39.6,46.9,2.4s16.94-65.65,29.81-82.88l-31.79-13.63Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1008,1129s12.69,23.15,13,31.32L986.73,1193l-46.37-40.49s5.84-15,19.56-24.4Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M987.84,1019.34l-1,5.43s14.06,2.3,19.7-11.93S987.84,1019.34,987.84,1019.34Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 42,
    height: 56,
    transform: "translate(969.9 943.42)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAA4CAYAAACL3WrLAAAACXBIWXMAAAsSAAALEgHS3X78AAABRklEQVRoQ+3aOw6DMBBF0QfrYJnUFNQsk32QJpM4jm3GH/AbidsS7KOBKJKV4TgOtGrf1uhi07wMsWuahhpoCpaqBF0ELQWG0qKzoC2BbhqsCnoV0C8FHmMXpLuQQHqvJPROpBTbMwrtgZRCewehPZGSb/iDMiBDnX6ZeuYO7QfKOk2AfKLAd3j0UOkDZX7sgJGJ7tt6mIACRiYKvKHs7ydgbaIWeqCte6CtMwGd5mUwAQWMTBQARgu/SoCliZ59oHdyekIPlaih7lkUNdTtgdbmH0HSQv0ooaEDXTpo7NR51JyfM0Q10aozfJZooGev4Kj50NVp9qeZ6FndoZppAg5Ue0PLcvbsNtEcJOBBc28urWSf2ydaggQC0NKFNNWsHZxozYKxate85dHXIgHFHwtqDyhaIAEFVMoFtwJKamgoF98a5vcC0ap/uoDQkI4AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1010.23,1036.38s-25.44,33.2-25.71,32-3.95-34.63-3.95-34.63l6.27-1.42,18.48,1.16Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M986.05,993.89c.22-1.89-.22-3.49-1-3.57s-1.55,1.37-1.76,3.25.21,3.49,1,3.58S985.83,995.78,986.05,993.89Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1003.07,995.71c.22-1.89-.22-3.49-1-3.58s-1.54,1.37-1.76,3.26.22,3.49,1,3.58S1002.85,997.59,1003.07,995.71Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M992,1004.45a.22.22,0,0,0,.17-.07,1.06,1.06,0,0,0,.21-1,.21.21,0,0,0-.15-.14,3.9,3.9,0,0,1-1.27-.38,1.21,1.21,0,0,1-.64-1,2,2,0,0,1,.38-.94l.09-.14c1.17-2,1.24-4.43,1.29-6.42a.19.19,0,0,0-.19-.2.2.2,0,0,0-.21.19c-.05,2-.11,4.36-1.23,6.23l-.08.14a2.19,2.19,0,0,0-.44,1.14,1.56,1.56,0,0,0,.83,1.29,3.8,3.8,0,0,0,1.27.42.67.67,0,0,1-.16.52.2.2,0,0,0,0,.28A.22.22,0,0,0,992,1004.45Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M999.56,987.7c2.75-1.83,8.05.62,7.55,4.17a.48.48,0,0,1-.78.27c-.83-.85-1.24-2-2.23-2.71-1.38-1-2.8-.86-4.39-1-.36,0-.42-.56-.15-.74Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M988.34,987c-2.15,0-4.05.84-6.14.93a.33.33,0,0,1-.2-.6c1.63-1.3,4.67-2.12,6.52-.87a.31.31,0,0,1-.18.54Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M976,987.48c.42-4.09.89-8.32,3-11.87a28.67,28.67,0,0,1,5.48-6.22,28.22,28.22,0,0,1,5.38-4.27,17.9,17.9,0,0,1,10-1.94,22.67,22.67,0,0,1,14,6,22.29,22.29,0,0,1,6.65,16.25,25.13,25.13,0,0,1-6.63,16.37,20.47,20.47,0,0,1-7.47-11.9c-.46-2.2-.55-4.48-1.2-6.62s-2-4.26-4.14-5a24.72,24.72,0,0,1-2.58-.76c-1-.48-1.77-1.41-2.79-1.88-2.73-1.23-5.73,1.43-6.79,4.24s-1.2,6-3,8.43c-1.16,1.59-2.88,2.65-4.33,4a15.32,15.32,0,0,0-4.75,13.33C974.81,999.86,975.41,993.56,976,987.48Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1012.53,999.92s2-5.09,6.06-1c1.6,1.61-.77,7.34-6.5,5.72C1012.09,1004.62,1010.42,1003.29,1012.53,999.92Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1036.87,1048.2s.3-2.1,4.15,6.72,2.1,15.61,5.13,21.46,6.79,22.15-1.24,25.74l-21.44,2.5s-3.32-4.21-4.32-7,0-8.28-.25-12.3-1.12-16.09-1.17-16.69,2.66-14.12,3.23-14.57S1036.87,1048.2,1036.87,1048.2Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M984.41,1086.13s12.91,11.42,24.66,3.13C1009.07,1089.26,997.9,1103,984.41,1086.13Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M987.35,1069.07c-.92,0-1.88,0-2.87-.12a.6.6,0,0,1-.56-.65.59.59,0,0,1,.65-.56c6.66.53,11.3-.77,13.79-3.88,3.59-4.48,1.52-11.32,1.5-11.39l-.37-1.17,1.16.42c12.64,4.7,21.64-9.55,21.73-9.69a.6.6,0,1,1,1,.63c-.09.15-9.11,14.46-22.12,10.55.48,2.27,1.13,7.51-2,11.39C996.94,1067.57,992.92,1069.07,987.35,1069.07Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M984.4,1068.88a.56.56,0,0,1-.3-.08c-5.56-3.19-8.6-6.91-9-11s2-7.78,3.51-9.55c-2.94.11-5.22-.63-6.81-2.27-3.33-3.43-2.34-9.38-2.3-9.63a.6.6,0,1,1,1.19.2c0,.06-.92,5.61,2,8.59,1.6,1.64,4.1,2.23,7.42,1.75l2-.28-1.5,1.33s-4.84,4.37-4.28,9.75c.39,3.73,3.23,7.13,8.43,10.11a.6.6,0,0,1-.3,1.13Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M996.79,1009.23s-2.81,5-6.48,4.13-4-5.88-4-5.88,2-1.51,3-1.5a3.87,3.87,0,0,1,2.22,1.18,3.53,3.53,0,0,1,2.06-.6C994.72,1006.65,996.1,1008.68,996.79,1009.23Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M986.43,1007.48l10.36,1.75S989.26,1015.37,986.43,1007.48Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1011.91,1287.82s-8.82,29.09,32.41,120.27l13.57-1s-16.09-84-13.73-120.3S1011.91,1287.82,1011.91,1287.82Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1043.56,1407.78l-2.54,7.47,12.68,18.42,10.59,4,2.57-1.8s-11.9-38.4-13.27-46-7.35,10.58-7.35,10.58Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1041.81,1412s6.88,3.24,16.2,23.44l8.85.47,18.29,10.8-30.61.72s-7.24-18.89-9.27-18.5-1.64,17.39-1.64,17.39l-2,0S1034.46,1417.93,1041.81,1412Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M979.59,1433.84s-6.89-27.82-6.18-34.52-12.31,2.7-12.31,2.7L959,1419.91s2.31,21.94,2.55,22.17,14.53,3.53,14.53,3.53l3.49-4.61Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "971.3 1405.03 975.34 1426.63 968.45 1436.4 946.87 1425.21 952.36 1392.82 955.2 1419.24 970.72 1418.21 971.3 1405.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M960.56,1408.9c-1.42-13.84-21.26-92.33-14.09-124.53s28-24.9,28.18-13.57-.72,138.39-.72,138.39Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M940.36,1152.47c-5.93,17.83-1.1,167.76-1.1,167.76l16.53-10.48,14.51,13.7,10.07-11.28,19.35,16.12,16.52-19,14.51,11.69,5.24-18.13,16.93,15.71s-22.57-138.24-33.45-162.82S940.36,1152.47,940.36,1152.47Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1023.47,1104.62l2,19.73-44.73,42.32,6,6.45s58.85-35.07,60.86-45.14-1.21-27-1.21-27Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M984.13,1162.85a53.43,53.43,0,0,0-12,5.21c-2.57,1.48-9.78,2.75-8.73,4.4s9.65-1.32,10.06-.84-1.57,5.09-1.57,5.09l6.62-4.65Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M991.6,1156.72l-15.23,11.19s-5.38,8.52-4.46,10,12.36,7.63,12.36,7.63,3.23-7.52,7.21-15.92c.06-.12,9.87-5.42,9.87-5.42Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M974.65,1174.2S961,1188.28,962,1189.53s11.69-9.79,11.69-9.79-9.3,14-8.17,15,11.87-13.06,11.87-13.06-6.3,15.09-5,15.71,8.82-13.85,8.82-13.85-2.83,12.8-1.69,13.33,4.81-11.38,4.81-11.38l2.52-7.85Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M888.73,1061.44l-13.51-12.92s-14.44-9.35-15.85-8.23-8.42,12-8.42,12,13.34,9,19.31,7.45c.14,0,13.89,6.71,13.89,6.71Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M876.43,1051.27a56.18,56.18,0,0,0-6.8-11.85c-1.84-2.5-4-9.86-5.59-8.57s2.48,9.89,2,10.37-5.48-1-5.48-1l5.61,6.34Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M843.62,1036.55h0a1.91,1.91,0,0,1,2.41-1.22l16.65,5.41a1.92,1.92,0,0,1,1.23,2.41h0a1.91,1.91,0,0,1-2.41,1.22L844.84,1039A1.91,1.91,0,0,1,843.62,1036.55Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M851.91,1043.14h0a1.91,1.91,0,0,1,2.41-1.22l6.51,2.11a1.93,1.93,0,0,1,1.23,2.41h0a1.93,1.93,0,0,1-2.41,1.23l-6.51-2.12A1.92,1.92,0,0,1,851.91,1043.14Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M852,1047.09h0a1.93,1.93,0,0,1,2.41-1.23l6.51,2.12a1.91,1.91,0,0,1,1.23,2.4h0a1.92,1.92,0,0,1-2.41,1.23l-6.51-2.12A1.91,1.91,0,0,1,852,1047.09Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 853.58,
    y: 1046.88,
    width: 3.47,
    height: 10.22,
    rx: 1.7,
    transform: "translate(2113.11 542.26) rotate(108.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 503.31,
    y: 738.32,
    width: 407.04,
    height: 691.98,
    rx: 19.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M526.74,748.19H886.92a11.1,11.1,0,0,1,11.1,11.1v611.06a0,0,0,0,1,0,0H515.64a0,0,0,0,1,0,0V759.29A11.1,11.1,0,0,1,526.74,748.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 608.81,
    cy: 997.67,
    r: 65.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M559.56,927.28c-2,0-3.56-1.18-3.56-2.64v-34.8c0-1.46,1.6-2.65,3.56-2.65s3.57,1.19,3.57,2.65v34.8C563.13,926.1,561.53,927.28,559.56,927.28Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M544.11,903.93a4.39,4.39,0,0,1-2-.46c-1.63-.82-2-2.47-.93-3.67l15.45-16.74a4,4,0,0,1,2.93-1.15h0a4,4,0,0,1,2.93,1.13l14.86,15.86c1.12,1.2.72,2.85-.9,3.68a4.39,4.39,0,0,1-5-.66l-11.9-12.71-12.53,13.57A4,4,0,0,1,544.11,903.93Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M584,910.57a29.18,29.18,0,0,1,.46-5.05,14.33,14.33,0,0,1,1.62-4.65,9.59,9.59,0,0,1,3.16-3.42,10.7,10.7,0,0,1,10.26,0,9.62,9.62,0,0,1,3.17,3.42,14.57,14.57,0,0,1,1.62,4.65,28.56,28.56,0,0,1,0,10.1,14.74,14.74,0,0,1-1.62,4.65,9.59,9.59,0,0,1-3.17,3.41,10.63,10.63,0,0,1-10.26,0,9.56,9.56,0,0,1-3.16-3.41,14.5,14.5,0,0,1-1.62-4.65A29.27,29.27,0,0,1,584,910.57Zm5.92,0c0,.74,0,1.62.1,2.64a12.58,12.58,0,0,0,.53,3,6.15,6.15,0,0,0,1.32,2.4,3.17,3.17,0,0,0,2.5,1,3.21,3.21,0,0,0,2.49-1,6.18,6.18,0,0,0,1.34-2.4,13.69,13.69,0,0,0,.53-3c.07-1,.1-1.9.1-2.64s0-1.62-.1-2.65a13.71,13.71,0,0,0-.53-2.95,6.23,6.23,0,0,0-1.34-2.41,3.24,3.24,0,0,0-2.49-1,3.21,3.21,0,0,0-2.5,1,6.19,6.19,0,0,0-1.32,2.41,12.59,12.59,0,0,0-.53,2.95C590,909,589.94,909.83,589.94,910.57Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M609.65,918.13h5.69l-3.55,11.13h-5Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M633,902.05H619.2v-5.44h20.42v5.2l-11.16,22.72h-6.89Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M661.48,901.81H650.39l-.11,4.3a7.81,7.81,0,0,1,2.48-.32,11.32,11.32,0,0,1,3.9.64,8.41,8.41,0,0,1,3.06,1.83,8.16,8.16,0,0,1,2,2.91,9.89,9.89,0,0,1,.71,3.85,10.59,10.59,0,0,1-.8,4.22,9.15,9.15,0,0,1-2.23,3.14,9.74,9.74,0,0,1-3.38,2,13.09,13.09,0,0,1-4.24.67,10.08,10.08,0,0,1-6.07-1.78,9,9,0,0,1-3.35-5.36l6.19-1.42a4,4,0,0,0,1.27,2.43,3.65,3.65,0,0,0,2.56.93,4,4,0,0,0,3-1.19,4.65,4.65,0,0,0,.55-5.26,4.17,4.17,0,0,0-1.5-1.42,5.93,5.93,0,0,0-2.07-.73,13.72,13.72,0,0,0-2.29-.2,15.48,15.48,0,0,0-2.94.28,20.67,20.67,0,0,0-2.86.74l.32-15.41h16.88Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M689,896.14a18.69,18.69,0,0,1,4.42.55,10.21,10.21,0,0,1,4,1.92l-3.78,4.62a5.79,5.79,0,0,0-2.17-1.2,11.15,11.15,0,0,0-2.49-.46v6.27l3.79,1.11a8.6,8.6,0,0,1,4.16,2.58,6.69,6.69,0,0,1,1.56,4.56,8.57,8.57,0,0,1-.75,3.66,8,8,0,0,1-2,2.69,10,10,0,0,1-3,1.73A15.2,15.2,0,0,1,689,925v2.76h-2.6V925a19.62,19.62,0,0,1-5.19-.71,11,11,0,0,1-4.55-2.49l4.18-4.69a5.71,5.71,0,0,0,2.48,1.8,11.73,11.73,0,0,0,3.08.65v-6.67l-2.88-.87a10.06,10.06,0,0,1-4.55-2.65,6.77,6.77,0,0,1-1.56-4.72,7.37,7.37,0,0,1,.75-3.35,8.07,8.07,0,0,1,2-2.56,10.63,10.63,0,0,1,2.88-1.74,12,12,0,0,1,3.37-.86v-2.76H689Zm-2.6,5.56a5.25,5.25,0,0,0-2,.82,2.08,2.08,0,0,0-.87,1.85,2.42,2.42,0,0,0,.36,1.42,2.91,2.91,0,0,0,.82.82,3.22,3.22,0,0,0,1,.4l.71.2Zm2.6,17.78a10,10,0,0,0,1.21-.33,4.3,4.3,0,0,0,1.08-.58,3.06,3.06,0,0,0,.77-.84,2.21,2.21,0,0,0,.29-1.17,2.25,2.25,0,0,0-.78-1.79,3.42,3.42,0,0,0-.83-.51q-.48-.22-1-.42l-.75-.27Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M741.27,883.64c2,0,3.56,1.18,3.56,2.64v34.81c0,1.46-1.6,2.64-3.56,2.64s-3.57-1.18-3.57-2.64V886.28C737.7,884.82,739.3,883.64,741.27,883.64Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M756.72,907a4.52,4.52,0,0,1,2,.46c1.63.83,2,2.47.93,3.68l-15.45,16.74a4.11,4.11,0,0,1-2.93,1.15h0a4,4,0,0,1-2.93-1.14L723.48,912c-1.12-1.2-.72-2.85.9-3.68a4.37,4.37,0,0,1,5,.67l11.9,12.71,12.53-13.58A4,4,0,0,1,756.72,907Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M769.35,913.31a29.33,29.33,0,0,1,.45-5,14.33,14.33,0,0,1,1.62-4.65,9.56,9.56,0,0,1,3.16-3.41,10.63,10.63,0,0,1,10.26,0,9.59,9.59,0,0,1,3.17,3.41,14.57,14.57,0,0,1,1.62,4.65,28.56,28.56,0,0,1,0,10.1A14.71,14.71,0,0,1,788,923a9.56,9.56,0,0,1-3.17,3.4,10.56,10.56,0,0,1-10.26,0,9.53,9.53,0,0,1-3.16-3.4,14.47,14.47,0,0,1-1.62-4.66A29.16,29.16,0,0,1,769.35,913.31Zm5.91,0c0,.74,0,1.62.1,2.64a12.49,12.49,0,0,0,.53,3,6.19,6.19,0,0,0,1.32,2.41,3.17,3.17,0,0,0,2.5,1,3.21,3.21,0,0,0,2.49-1,6.23,6.23,0,0,0,1.34-2.41,13.58,13.58,0,0,0,.53-3c.07-1,.1-1.9.1-2.64s0-1.61-.1-2.64a13.6,13.6,0,0,0-.53-2.95,6.34,6.34,0,0,0-1.34-2.42,3.24,3.24,0,0,0-2.49-1,3.2,3.2,0,0,0-2.5,1,6.31,6.31,0,0,0-1.32,2.42,12.49,12.49,0,0,0-.53,2.95C775.29,911.7,775.26,912.58,775.26,913.31Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M795,920.88h5.69L797.11,932h-5.05Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M804.36,913.31a29.36,29.36,0,0,1,.46-5,14.33,14.33,0,0,1,1.62-4.65,9.56,9.56,0,0,1,3.16-3.41,10.63,10.63,0,0,1,10.26,0,9.59,9.59,0,0,1,3.17,3.41,14.57,14.57,0,0,1,1.62,4.65,28.56,28.56,0,0,1,0,10.1A14.71,14.71,0,0,1,823,923a9.56,9.56,0,0,1-3.17,3.4,10.56,10.56,0,0,1-10.26,0,9.53,9.53,0,0,1-3.16-3.4,14.47,14.47,0,0,1-1.62-4.66A29.18,29.18,0,0,1,804.36,913.31Zm5.92,0c0,.74,0,1.62.1,2.64a12.49,12.49,0,0,0,.53,3,6.19,6.19,0,0,0,1.32,2.41,3.17,3.17,0,0,0,2.5,1,3.21,3.21,0,0,0,2.49-1,6.23,6.23,0,0,0,1.34-2.41,13.58,13.58,0,0,0,.53-3c.07-1,.1-1.9.1-2.64s0-1.61-.1-2.64a13.6,13.6,0,0,0-.53-2.95,6.34,6.34,0,0,0-1.34-2.42,3.24,3.24,0,0,0-2.49-1,3.2,3.2,0,0,0-2.5,1,6.31,6.31,0,0,0-1.32,2.42,12.49,12.49,0,0,0-.53,2.95C810.31,911.7,810.28,912.58,810.28,913.31Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M846.8,904.56H835.71l-.11,4.3a7.53,7.53,0,0,1,2.48-.32,11.56,11.56,0,0,1,3.9.63A8.43,8.43,0,0,1,845,911a8.16,8.16,0,0,1,2,2.91,9.86,9.86,0,0,1,.71,3.85,10.59,10.59,0,0,1-.8,4.22,9.15,9.15,0,0,1-2.23,3.14,9.56,9.56,0,0,1-3.38,1.94,12.81,12.81,0,0,1-4.23.68A10.09,10.09,0,0,1,831,926a9,9,0,0,1-3.35-5.36l6.19-1.42a4,4,0,0,0,1.27,2.43,3.69,3.69,0,0,0,2.56.92,4,4,0,0,0,3-1.19,4.14,4.14,0,0,0,1.12-3,3.91,3.91,0,0,0-2.07-3.68,5.93,5.93,0,0,0-2.07-.73,13.62,13.62,0,0,0-2.29-.2,15.54,15.54,0,0,0-2.94.27,20.19,20.19,0,0,0-2.85.75l.31-15.41H846.8Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M874.37,898.88a18.68,18.68,0,0,1,4.41.55,10.23,10.23,0,0,1,4,1.93L879,906a6,6,0,0,0-2.17-1.21,11.75,11.75,0,0,0-2.48-.45v6.27l3.78,1.11a8.6,8.6,0,0,1,4.16,2.58,6.68,6.68,0,0,1,1.56,4.56,8.57,8.57,0,0,1-.75,3.66,7.89,7.89,0,0,1-2,2.68,9.62,9.62,0,0,1-3,1.73,15.44,15.44,0,0,1-3.67.84v2.76h-2.6v-2.76a19.63,19.63,0,0,1-5.2-.71,11.28,11.28,0,0,1-4.55-2.49l4.18-4.69a5.76,5.76,0,0,0,2.48,1.8,12.14,12.14,0,0,0,3.09.65v-6.67l-2.89-.87a10,10,0,0,1-4.55-2.66,6.74,6.74,0,0,1-1.56-4.72,7.35,7.35,0,0,1,.75-3.34,8,8,0,0,1,2-2.57,10.89,10.89,0,0,1,2.88-1.74,12.72,12.72,0,0,1,3.38-.86v-2.76h2.6Zm-2.6,5.56a5.48,5.48,0,0,0-2,.83,2.07,2.07,0,0,0-.87,1.85,2.42,2.42,0,0,0,.36,1.42,2.87,2.87,0,0,0,.82.81,3.2,3.2,0,0,0,1,.41l.71.2Zm2.6,17.78a8.68,8.68,0,0,0,1.2-.33,4.27,4.27,0,0,0,1.08-.57,3,3,0,0,0,.77-.85,2.2,2.2,0,0,0,.29-1.16,2.3,2.3,0,0,0-.21-1.07,2.44,2.44,0,0,0-.57-.73,3.42,3.42,0,0,0-.83-.51c-.32-.15-.65-.28-1-.41l-.74-.28Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M894,769.77H533.84a11.1,11.1,0,0,0-11.1,11.1v78.42H905.12V780.87A11.1,11.1,0,0,0,894,769.77Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 565.93,
    cy: 791.92,
    r: 31.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M562.79,790.4h5.85a14.94,14.94,0,0,1,14.94,14.94v6.17a0,0,0,0,1,0,0H547.84a0,0,0,0,1,0,0v-6.17A14.94,14.94,0,0,1,562.79,790.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 565.72,
    cy: 777.34,
    r: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 580.21,
    y: 1242.92,
    width: 248.11,
    height: 99.78,
    rx: 27.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M643.06,1288.53h18.19a45.8,45.8,0,0,1,6.37.45,17.61,17.61,0,0,1,5.75,1.79,11,11,0,0,1,4.13,3.76,11.45,11.45,0,0,1,1.58,6.4,10.23,10.23,0,0,1-2.3,6.86,12.71,12.71,0,0,1-6.1,3.89v.14a14.1,14.1,0,0,1,4.38,1.34,11.76,11.76,0,0,1,3.37,2.55,10.6,10.6,0,0,1,2.17,3.62,12.52,12.52,0,0,1,.76,4.4,11.77,11.77,0,0,1-1.65,6.45,13,13,0,0,1-4.27,4.16,18.69,18.69,0,0,1-5.9,2.28,31.46,31.46,0,0,1-6.51.69h-20Zm10.75,19.5h7.78a10.71,10.71,0,0,0,2.45-.28,6.7,6.7,0,0,0,2.16-.89,4.84,4.84,0,0,0,1.56-1.65,5.09,5.09,0,0,0,.58-2.49,4.46,4.46,0,0,0-.66-2.51,4.55,4.55,0,0,0-1.68-1.55,8,8,0,0,0-2.34-.79,14.25,14.25,0,0,0-2.55-.24h-7.3Zm0,20.18h9.64a12,12,0,0,0,2.51-.27,6.79,6.79,0,0,0,2.31-1,5.37,5.37,0,0,0,1.69-1.79,5.23,5.23,0,0,0,.65-2.69,4.3,4.3,0,0,0-.86-2.79,5.47,5.47,0,0,0-2.17-1.61,11,11,0,0,0-2.82-.76,20.65,20.65,0,0,0-2.83-.21h-8.12Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M728.83,1318.5a23.58,23.58,0,0,1-1.31,8,17.66,17.66,0,0,1-3.89,6.34,17.87,17.87,0,0,1-6.45,4.2,26.93,26.93,0,0,1-17.84,0,17.83,17.83,0,0,1-6.44-4.2,17.52,17.52,0,0,1-3.89-6.34,23.33,23.33,0,0,1-1.31-8v-30h10.75v29.56a11.73,11.73,0,0,0,.72,4.2,10,10,0,0,0,2,3.34,9,9,0,0,0,3.14,2.2,9.76,9.76,0,0,0,4,.8,9.54,9.54,0,0,0,3.92-.8,9.13,9.13,0,0,0,3.1-2.2,9.67,9.67,0,0,0,2-3.34,11.73,11.73,0,0,0,.73-4.2v-29.56h10.75Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M750.73,1316.5l-18.32-28h13.36l10.33,18.26,11-18.26H779.8l-18.32,28v20.81H750.73Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M720.71,1010.1a24.24,24.24,0,1,1,23.8-24.24A24,24,0,0,1,720.71,1010.1Zm0-37.29a13.05,13.05,0,1,0,12.82,13.05A13,13,0,0,0,720.71,972.81Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M720.71,1010.1a24.23,24.23,0,0,0,1-48.42v11.23a13,13,0,0,1-1,26,12.58,12.58,0,0,1-7.36-2.4l-7.58,8.18A23.34,23.34,0,0,0,720.71,1010.1Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M721.7,961.68v11.23a12.88,12.88,0,0,1,11.71,11.68l9.61-7.08A23.87,23.87,0,0,0,721.7,961.68Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M720.71,1078.19a24.24,24.24,0,1,1,23.8-24.23A24,24,0,0,1,720.71,1078.19Zm0-37.28a13.05,13.05,0,1,0,12.82,13A12.95,12.95,0,0,0,720.71,1040.91Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M720.71,1078.19a24.23,24.23,0,0,0,1-48.42V1041a13,13,0,0,1-1,26,12.58,12.58,0,0,1-7.36-2.4l-7.58,8.18A23.39,23.39,0,0,0,720.71,1078.19Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M721.7,1029.77V1041a12.88,12.88,0,0,1,11.71,11.68l9.61-7.09A23.89,23.89,0,0,0,721.7,1029.77Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M698.89,796.92H629.11a3.55,3.55,0,0,1-3.54-3.54h0a3.55,3.55,0,0,1,3.54-3.54h69.78a3.55,3.55,0,0,1,3.54,3.54h0A3.55,3.55,0,0,1,698.89,796.92Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M629.11,810.07H747.44a3.54,3.54,0,0,1,3.53,3.54h0a3.54,3.54,0,0,1-3.53,3.54H629.11a3.55,3.55,0,0,1-3.54-3.54h0A3.55,3.55,0,0,1,629.11,810.07Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M758.83,972l-2,1.72-1.17-1.35,3.18-2.68h1.93v9.75h-2Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M763.47,974.58a9.76,9.76,0,0,1,.16-1.76,5,5,0,0,1,.56-1.62,3.36,3.36,0,0,1,1.11-1.2,3.71,3.71,0,0,1,3.58,0,3.36,3.36,0,0,1,1.11,1.2,5.28,5.28,0,0,1,.57,1.62,9.82,9.82,0,0,1,0,3.53A5.28,5.28,0,0,1,770,978a3.25,3.25,0,0,1-1.11,1.19,3.64,3.64,0,0,1-3.58,0,3.25,3.25,0,0,1-1.11-1.19,5,5,0,0,1-.56-1.62A9.79,9.79,0,0,1,763.47,974.58Zm2.07,0q0,.39,0,.93a4.36,4.36,0,0,0,.19,1,2.14,2.14,0,0,0,.46.84,1.11,1.11,0,0,0,.87.35,1.12,1.12,0,0,0,.87-.35,2.16,2.16,0,0,0,.47-.84,4.36,4.36,0,0,0,.18-1c0-.36,0-.67,0-.93s0-.56,0-.92a4.36,4.36,0,0,0-.18-1,2.16,2.16,0,0,0-.47-.84,1.12,1.12,0,0,0-.87-.35,1.11,1.11,0,0,0-.87.35,2.14,2.14,0,0,0-.46.84,4.36,4.36,0,0,0-.19,1C765.55,974,765.54,974.33,765.54,974.58Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M772.42,977.23h2l-1.25,3.88H771.4Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M779.2,973.19l.33-.06a2,2,0,0,1,.34,0,3,3,0,0,1,1.26.25,2.89,2.89,0,0,1,1.58,1.68,3.46,3.46,0,0,1,.22,1.25,3.16,3.16,0,0,1-1,2.42,3.35,3.35,0,0,1-1.16.68,4.21,4.21,0,0,1-2.86,0,3.4,3.4,0,0,1-1.15-.68,3.16,3.16,0,0,1-1.05-2.42,4.1,4.1,0,0,1,.1-1,4.34,4.34,0,0,1,.25-.82,6.24,6.24,0,0,1,.37-.73c.14-.24.29-.48.45-.73l2.13-3.33h2.53Zm1.67,3a1.5,1.5,0,0,0-.44-1.1,1.71,1.71,0,0,0-2.27,0,1.49,1.49,0,0,0-.43,1.1,1.47,1.47,0,0,0,.43,1.09,1.68,1.68,0,0,0,2.27,0A1.48,1.48,0,0,0,780.87,976.2Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M784.21,972.23a2.6,2.6,0,0,1,.26-1.18,2.46,2.46,0,0,1,.7-.84,3.14,3.14,0,0,1,1-.5,4.7,4.7,0,0,1,1.27-.17,4.62,4.62,0,0,1,1.26.17,3.14,3.14,0,0,1,1,.5,2.43,2.43,0,0,1,1,2,2.15,2.15,0,0,1-.43,1.36,2.29,2.29,0,0,1-1.22.8v0a2.49,2.49,0,0,1,1.35.85,2.42,2.42,0,0,1,.47,1.52,2.61,2.61,0,0,1-1,2.13,3.62,3.62,0,0,1-1.1.53,4.57,4.57,0,0,1-1.29.18,4.64,4.64,0,0,1-1.3-.18,3.46,3.46,0,0,1-1.09-.53,2.54,2.54,0,0,1-1-2.13,2.41,2.41,0,0,1,.46-1.52,2.48,2.48,0,0,1,1.36-.85v0a2.21,2.21,0,0,1-1.22-.8A2.15,2.15,0,0,1,784.21,972.23Zm1.9,4.27a1.19,1.19,0,0,0,.37.87,1.56,1.56,0,0,0,2,0,1.22,1.22,0,0,0,0-1.75,1.56,1.56,0,0,0-2,0A1.2,1.2,0,0,0,786.11,976.5Zm.17-4a1,1,0,0,0,.33.77,1.33,1.33,0,0,0,1.73,0,1.05,1.05,0,0,0,0-1.53,1.33,1.33,0,0,0-1.73,0A1,1,0,0,0,786.28,972.52Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M795.76,976c-.12,0-.22,0-.34.06a1.87,1.87,0,0,1-.34,0,3,3,0,0,1-1.25-.25,2.9,2.9,0,0,1-1-.67,3.12,3.12,0,0,1-.62-1,3.46,3.46,0,0,1-.22-1.25,3.23,3.23,0,0,1,.29-1.37,3,3,0,0,1,.77-1,3.33,3.33,0,0,1,1.15-.69,4.35,4.35,0,0,1,2.85,0,3.28,3.28,0,0,1,1.16.69,3.11,3.11,0,0,1,.77,1,3.23,3.23,0,0,1,.29,1.37,4.72,4.72,0,0,1-.1,1,4.36,4.36,0,0,1-.26.82,4.54,4.54,0,0,1-.37.73c-.14.24-.29.48-.45.73L796,979.46h-2.52Zm-1.67-3a1.49,1.49,0,0,0,.43,1.1,1.54,1.54,0,0,0,1.14.43,1.49,1.49,0,0,0,1.57-1.53,1.48,1.48,0,0,0-.44-1.09,1.51,1.51,0,0,0-1.13-.44,1.54,1.54,0,0,0-1.14.44A1.47,1.47,0,0,0,794.09,973Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M800.16,974.58a10.76,10.76,0,0,1,.16-1.76,5.28,5.28,0,0,1,.57-1.62A3.36,3.36,0,0,1,802,970a3.23,3.23,0,0,1,1.79-.46,3.28,3.28,0,0,1,1.79.46,3.55,3.55,0,0,1,1.11,1.2,5.27,5.27,0,0,1,.56,1.62,9.82,9.82,0,0,1,0,3.53,5.27,5.27,0,0,1-.56,1.62,3.43,3.43,0,0,1-1.11,1.19,3.2,3.2,0,0,1-1.79.47,3.15,3.15,0,0,1-1.79-.47,3.25,3.25,0,0,1-1.11-1.19,5.28,5.28,0,0,1-.57-1.62A10.78,10.78,0,0,1,800.16,974.58Zm2.07,0q0,.39,0,.93a4.94,4.94,0,0,0,.19,1,2.14,2.14,0,0,0,.46.84,1.13,1.13,0,0,0,.88.35,1.11,1.11,0,0,0,.86-.35,2.16,2.16,0,0,0,.47-.84,4.36,4.36,0,0,0,.19-1q0-.54,0-.93c0-.25,0-.56,0-.92a4.36,4.36,0,0,0-.19-1,2.16,2.16,0,0,0-.47-.84,1.11,1.11,0,0,0-.86-.35,1.13,1.13,0,0,0-.88.35,2.14,2.14,0,0,0-.46.84,4.94,4.94,0,0,0-.19,1C802.24,974,802.23,974.33,802.23,974.58Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M810.84,973.55h.67a3.64,3.64,0,0,0,.57,0,1.63,1.63,0,0,0,.5-.16A1.06,1.06,0,0,0,813,973a1,1,0,0,0,.13-.56.9.9,0,0,0-.35-.73,1.31,1.31,0,0,0-.86-.29,1.19,1.19,0,0,0-.8.27,1.17,1.17,0,0,0-.41.64l-2.28-.47a3.37,3.37,0,0,1,.5-1.08,2.71,2.71,0,0,1,.79-.72,3.63,3.63,0,0,1,1-.41,5.54,5.54,0,0,1,1.18-.13,5.08,5.08,0,0,1,1.24.16,3.14,3.14,0,0,1,1.06.5,2.54,2.54,0,0,1,.72.84,2.61,2.61,0,0,1,.27,1.22,2.25,2.25,0,0,1-.43,1.39,2,2,0,0,1-1.24.74v0a1.9,1.9,0,0,1,.78.27,1.84,1.84,0,0,1,.57.5,2.27,2.27,0,0,1,.36.69A3,3,0,0,1,815,978a2.68,2.68,0,0,1-.76.91,3,3,0,0,1-1.11.55,5,5,0,0,1-1.36.18,4.11,4.11,0,0,1-2.25-.61,3,3,0,0,1-1.25-1.91l2.18-.51a1.32,1.32,0,0,0,1.44,1.13,1.27,1.27,0,0,0,1-.36,1.25,1.25,0,0,0,.33-.9,1.08,1.08,0,0,0-.17-.64,1.17,1.17,0,0,0-.45-.34,2.35,2.35,0,0,0-.62-.13l-.69,0h-.48Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M821.17,969.71h6.62v2h-4.47v1.82h4.22v2h-4.22v2H828v2h-6.87Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M838,975.7a4.59,4.59,0,0,1-.27,1.6,3.5,3.5,0,0,1-.77,1.27,3.9,3.9,0,0,1-1.29.84,5.46,5.46,0,0,1-3.57,0,3.9,3.9,0,0,1-1.29-.84,3.66,3.66,0,0,1-.78-1.27,4.84,4.84,0,0,1-.26-1.6v-6h2.15v5.91a2.32,2.32,0,0,0,.15.84,2.06,2.06,0,0,0,.4.67,2,2,0,0,0,.63.44,2,2,0,0,0,1.58,0,2.26,2.26,0,0,0,.62-.44,2.06,2.06,0,0,0,.4-.67,2.32,2.32,0,0,0,.15-.84v-5.91H838Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M840,969.71h3.77a7.2,7.2,0,0,1,1.42.14,3.6,3.6,0,0,1,1.17.48,2.52,2.52,0,0,1,.8.91,3.19,3.19,0,0,1,.29,1.43,2.94,2.94,0,0,1-.53,1.76,2.45,2.45,0,0,1-1.58.91l2.48,4.12h-2.57l-2-3.9h-1.06v3.9H840Zm2.15,4h1.27c.19,0,.39,0,.61,0a1.71,1.71,0,0,0,.58-.12,1.09,1.09,0,0,0,.44-.32,1,1,0,0,0,.17-.62,1.07,1.07,0,0,0-.15-.6,1,1,0,0,0-.39-.33,1.65,1.65,0,0,0-.53-.16,4.12,4.12,0,0,0-.6,0h-1.4Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M852,969l1.57.48-4.13,10.73-1.56-.48Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M862.73,975.7a4.59,4.59,0,0,1-.27,1.6,3.39,3.39,0,0,1-.78,1.27,3.75,3.75,0,0,1-1.28.84,5.46,5.46,0,0,1-3.57,0,3.9,3.9,0,0,1-1.29-.84,3.66,3.66,0,0,1-.78-1.27,4.84,4.84,0,0,1-.26-1.6v-6h2.15v5.91a2.32,2.32,0,0,0,.15.84,2.06,2.06,0,0,0,.4.67,2,2,0,0,0,.63.44,2,2,0,0,0,1.58,0,2.26,2.26,0,0,0,.62-.44,2.06,2.06,0,0,0,.4-.67,2.32,2.32,0,0,0,.15-.84v-5.91h2.15Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M869.53,972.09a1.59,1.59,0,0,0-.71-.49,2.7,2.7,0,0,0-.85-.16,2.1,2.1,0,0,0-.48.06,2,2,0,0,0-.47.17,1.08,1.08,0,0,0-.36.31.81.81,0,0,0-.13.47.8.8,0,0,0,.33.68,3.38,3.38,0,0,0,.83.39l1.08.33a4.77,4.77,0,0,1,1.08.47,2.5,2.5,0,0,1,.83.82,2.38,2.38,0,0,1,.34,1.36,3.19,3.19,0,0,1-.31,1.42,2.76,2.76,0,0,1-.82,1,3.42,3.42,0,0,1-1.19.6,5.68,5.68,0,0,1-1.44.19,5.34,5.34,0,0,1-1.77-.29,4.42,4.42,0,0,1-1.51-.94l1.53-1.68a2.19,2.19,0,0,0,.83.68,2.41,2.41,0,0,0,1,.25,2.49,2.49,0,0,0,.53-.07,1.71,1.71,0,0,0,.48-.18,1.2,1.2,0,0,0,.35-.32.87.87,0,0,0-.21-1.15,3.21,3.21,0,0,0-.85-.43c-.34-.12-.7-.24-1.1-.36a5.16,5.16,0,0,1-1.1-.48,2.82,2.82,0,0,1-.85-.8,2.33,2.33,0,0,1-.33-1.31,3,3,0,0,1,.3-1.38,3.18,3.18,0,0,1,.83-1,3.51,3.51,0,0,1,1.19-.6,5,5,0,0,1,1.39-.2,5.68,5.68,0,0,1,1.6.23,3.64,3.64,0,0,1,1.39.79Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M872.62,969.71h3.22a9.38,9.38,0,0,1,2.22.26,5,5,0,0,1,1.84.85,4.16,4.16,0,0,1,1.25,1.52,5,5,0,0,1,.46,2.27,4.63,4.63,0,0,1-.45,2.09,4.56,4.56,0,0,1-1.2,1.51,5.35,5.35,0,0,1-1.75.93,6.85,6.85,0,0,1-2.08.32h-3.51Zm2.14,7.77h1.12a6,6,0,0,0,1.38-.15,3,3,0,0,0,1.11-.51,2.41,2.41,0,0,0,.74-.92,3.27,3.27,0,0,0,.27-1.4,2.7,2.7,0,0,0-.27-1.24,2.49,2.49,0,0,0-.72-.88,3.33,3.33,0,0,0-1.07-.52,5,5,0,0,0-1.29-.17h-1.27Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M758.83,1040.44l-2,1.73-1.17-1.35,3.18-2.69h1.93v9.75h-2Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M763.47,1043a9.79,9.79,0,0,1,.16-1.77,5,5,0,0,1,.56-1.62,3.33,3.33,0,0,1,1.11-1.19,3.71,3.71,0,0,1,3.58,0,3.33,3.33,0,0,1,1.11,1.19,5.28,5.28,0,0,1,.57,1.62,10.78,10.78,0,0,1,.16,1.77,10.66,10.66,0,0,1-.16,1.76,5.34,5.34,0,0,1-.57,1.63,3.42,3.42,0,0,1-1.11,1.19,3.71,3.71,0,0,1-3.58,0,3.42,3.42,0,0,1-1.11-1.19,5.07,5.07,0,0,1-.56-1.63A9.68,9.68,0,0,1,763.47,1043Zm2.07,0c0,.25,0,.56,0,.92a4.36,4.36,0,0,0,.19,1,2.14,2.14,0,0,0,.46.84,1.11,1.11,0,0,0,.87.35,1.12,1.12,0,0,0,.87-.35,2.16,2.16,0,0,0,.47-.84,4.36,4.36,0,0,0,.18-1c0-.36,0-.67,0-.92s0-.57,0-.93a4.45,4.45,0,0,0-.18-1,2.16,2.16,0,0,0-.47-.84,1.12,1.12,0,0,0-.87-.34,1.1,1.1,0,0,0-.87.34,2.14,2.14,0,0,0-.46.84,4.46,4.46,0,0,0-.19,1Q765.54,1042.62,765.54,1043Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M772.42,1045.65h2l-1.25,3.89H771.4Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M779.2,1041.62l.33-.07a2,2,0,0,1,.34,0,3,3,0,0,1,1.26.25,3,3,0,0,1,1,.67,3.06,3.06,0,0,1,.62,1,3.46,3.46,0,0,1,.22,1.25,3.2,3.2,0,0,1-.28,1.37,3.4,3.4,0,0,1-.77,1.06,3.52,3.52,0,0,1-1.16.68,4.38,4.38,0,0,1-2.86,0,3.57,3.57,0,0,1-1.15-.68,3.4,3.4,0,0,1-.77-1.06,3.2,3.2,0,0,1-.28-1.37,4.1,4.1,0,0,1,.1-1,4.34,4.34,0,0,1,.25-.82,6.24,6.24,0,0,1,.37-.73c.14-.24.29-.48.45-.73l2.13-3.33h2.53Zm1.67,3a1.5,1.5,0,0,0-.44-1.1,1.71,1.71,0,0,0-2.27,0,1.49,1.49,0,0,0-.43,1.1,1.47,1.47,0,0,0,.43,1.09,1.68,1.68,0,0,0,2.27,0A1.48,1.48,0,0,0,780.87,1044.62Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M784.21,1040.65a2.6,2.6,0,0,1,.26-1.18,2.46,2.46,0,0,1,.7-.84,3.14,3.14,0,0,1,1-.5,4.7,4.7,0,0,1,1.27-.16,4.63,4.63,0,0,1,1.26.16,3.14,3.14,0,0,1,1,.5,2.43,2.43,0,0,1,1,2,2.2,2.2,0,0,1-.43,1.37,2.33,2.33,0,0,1-1.22.79v0a2.49,2.49,0,0,1,1.35.85,2.44,2.44,0,0,1,.47,1.52,2.61,2.61,0,0,1-.29,1.24,2.5,2.5,0,0,1-.75.89,3.62,3.62,0,0,1-1.1.53,4.57,4.57,0,0,1-1.29.18,4.64,4.64,0,0,1-1.3-.18,3.46,3.46,0,0,1-1.09-.53,2.53,2.53,0,0,1-.76-.89,2.61,2.61,0,0,1-.28-1.24,2.43,2.43,0,0,1,.46-1.52,2.48,2.48,0,0,1,1.36-.85v0a2.25,2.25,0,0,1-1.22-.79A2.2,2.2,0,0,1,784.21,1040.65Zm1.9,4.27a1.19,1.19,0,0,0,.37.87,1.56,1.56,0,0,0,2,0,1.22,1.22,0,0,0,0-1.75,1.56,1.56,0,0,0-2,0A1.2,1.2,0,0,0,786.11,1044.92Zm.17-4a1,1,0,0,0,.33.77,1.33,1.33,0,0,0,1.73,0,1.05,1.05,0,0,0,0-1.53,1.36,1.36,0,0,0-1.73,0A1,1,0,0,0,786.28,1040.94Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M795.76,1044.4l-.34.07a1.88,1.88,0,0,1-.34,0,3.13,3.13,0,0,1-1.25-.24,2.93,2.93,0,0,1-1-.68,3.12,3.12,0,0,1-.62-1,3.46,3.46,0,0,1-.22-1.25,3.23,3.23,0,0,1,.29-1.37,3,3,0,0,1,.77-1,3.31,3.31,0,0,1,1.15-.68,4.35,4.35,0,0,1,2.85,0,3.26,3.26,0,0,1,1.16.68,3.11,3.11,0,0,1,.77,1,3.23,3.23,0,0,1,.29,1.37,4.72,4.72,0,0,1-.1,1,4.36,4.36,0,0,1-.26.82,5.11,5.11,0,0,1-.37.74l-.45.72-2.13,3.33h-2.52Zm-1.67-3a1.47,1.47,0,0,0,.43,1.09,1.54,1.54,0,0,0,1.14.43,1.5,1.5,0,0,0,1.13-.43,1.58,1.58,0,0,0,0-2.19,1.5,1.5,0,0,0-1.13-.43,1.54,1.54,0,0,0-1.14.43A1.48,1.48,0,0,0,794.09,1041.4Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M800.16,1043a10.78,10.78,0,0,1,.16-1.77,5.28,5.28,0,0,1,.57-1.62,3.33,3.33,0,0,1,1.11-1.19,3.15,3.15,0,0,1,1.79-.46,3.2,3.2,0,0,1,1.79.46,3.52,3.52,0,0,1,1.11,1.19,5.27,5.27,0,0,1,.56,1.62,9.79,9.79,0,0,1,.16,1.77,9.68,9.68,0,0,1-.16,1.76,5.33,5.33,0,0,1-.56,1.63,3.61,3.61,0,0,1-1.11,1.19,3.28,3.28,0,0,1-1.79.46,3.23,3.23,0,0,1-1.79-.46,3.42,3.42,0,0,1-1.11-1.19,5.34,5.34,0,0,1-.57-1.63A10.66,10.66,0,0,1,800.16,1043Zm2.07,0c0,.25,0,.56,0,.92a4.94,4.94,0,0,0,.19,1,2.14,2.14,0,0,0,.46.84,1.13,1.13,0,0,0,.88.35,1.11,1.11,0,0,0,.86-.35,2.16,2.16,0,0,0,.47-.84,4.36,4.36,0,0,0,.19-1c0-.36,0-.67,0-.92s0-.57,0-.93a4.46,4.46,0,0,0-.19-1,2.16,2.16,0,0,0-.47-.84,1.11,1.11,0,0,0-.86-.34,1.12,1.12,0,0,0-.88.34,2.14,2.14,0,0,0-.46.84,5.06,5.06,0,0,0-.19,1Q802.23,1042.62,802.23,1043Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M810.84,1042h.67a3.64,3.64,0,0,0,.57,0,1.63,1.63,0,0,0,.5-.16.9.9,0,0,0,.37-.33,1,1,0,0,0,.13-.55.88.88,0,0,0-.35-.73,1.26,1.26,0,0,0-.86-.29,1.19,1.19,0,0,0-.8.26,1.17,1.17,0,0,0-.41.64l-2.28-.46a3.32,3.32,0,0,1,.5-1.09,2.86,2.86,0,0,1,.79-.72,3.33,3.33,0,0,1,1-.4,5,5,0,0,1,1.18-.13,5.07,5.07,0,0,1,1.24.15,3.14,3.14,0,0,1,1.06.5,2.48,2.48,0,0,1,.72.85,2.54,2.54,0,0,1,.27,1.21,2.25,2.25,0,0,1-.43,1.39,1.93,1.93,0,0,1-1.24.74v0a2,2,0,0,1,1.35.77,2.11,2.11,0,0,1,.36.68,3,3,0,0,1-.16,2.1,2.72,2.72,0,0,1-.76.92,3.19,3.19,0,0,1-1.11.54,5,5,0,0,1-1.36.18,4,4,0,0,1-2.25-.61,3,3,0,0,1-1.25-1.91l2.18-.51a1.41,1.41,0,0,0,.45.82,1.38,1.38,0,0,0,1,.31,1.3,1.3,0,0,0,1-.35,1.29,1.29,0,0,0,.33-.91,1.08,1.08,0,0,0-.17-.64,1.06,1.06,0,0,0-.45-.33,1.76,1.76,0,0,0-.62-.13l-.69,0h-.48Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M821.17,1038.13h6.62v2h-4.47v1.82h4.22v2h-4.22v2H828v2h-6.87Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M838,1044.12a4.59,4.59,0,0,1-.27,1.6A3.5,3.5,0,0,1,837,1047a3.61,3.61,0,0,1-1.29.84,5.46,5.46,0,0,1-3.57,0,3.61,3.61,0,0,1-1.29-.84,3.66,3.66,0,0,1-.78-1.27,4.84,4.84,0,0,1-.26-1.6v-6h2.15V1044a2.32,2.32,0,0,0,.15.84,2,2,0,0,0,.4.67,1.88,1.88,0,0,0,.63.44,1.94,1.94,0,0,0,2.2-.44,2,2,0,0,0,.4-.67,2.32,2.32,0,0,0,.15-.84v-5.91H838Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M840,1038.13h3.77a6.51,6.51,0,0,1,1.42.15,3.21,3.21,0,0,1,1.17.48,2.44,2.44,0,0,1,.8.91,3.15,3.15,0,0,1,.29,1.42,2.92,2.92,0,0,1-.53,1.76,2.41,2.41,0,0,1-1.58.91l2.48,4.12h-2.57l-2-3.9h-1.06v3.9H840Zm2.15,4h1.27l.61,0a2,2,0,0,0,.58-.13,1,1,0,0,0,.44-.32,1.23,1.23,0,0,0,0-1.21,1,1,0,0,0-.39-.34,1.65,1.65,0,0,0-.53-.16,4.12,4.12,0,0,0-.6,0h-1.4Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M852,1037.4l1.57.48-4.13,10.73-1.56-.48Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M862.73,1044.12a4.59,4.59,0,0,1-.27,1.6,3.39,3.39,0,0,1-.78,1.27,3.48,3.48,0,0,1-1.28.84,5.46,5.46,0,0,1-3.57,0,3.61,3.61,0,0,1-1.29-.84,3.66,3.66,0,0,1-.78-1.27,4.84,4.84,0,0,1-.26-1.6v-6h2.15V1044a2.32,2.32,0,0,0,.15.84,2,2,0,0,0,.4.67,1.88,1.88,0,0,0,.63.44,1.94,1.94,0,0,0,2.2-.44,2,2,0,0,0,.4-.67,2.32,2.32,0,0,0,.15-.84v-5.91h2.15Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M869.53,1040.51a1.59,1.59,0,0,0-.71-.49,2.68,2.68,0,0,0-.85-.15,2.06,2.06,0,0,0-.48.05,2.64,2.64,0,0,0-.47.17,1.21,1.21,0,0,0-.36.31.81.81,0,0,0-.13.47.78.78,0,0,0,.33.68,3.38,3.38,0,0,0,.83.4l1.08.33a4.34,4.34,0,0,1,1.08.46,2.6,2.6,0,0,1,.83.82,2.38,2.38,0,0,1,.34,1.36,3.16,3.16,0,0,1-.31,1.42,2.88,2.88,0,0,1-.82,1,3.59,3.59,0,0,1-1.19.59,5.27,5.27,0,0,1-1.44.19,5.34,5.34,0,0,1-1.77-.29,4.39,4.39,0,0,1-1.51-.93l1.53-1.69a2.22,2.22,0,0,0,.83.69,2.4,2.4,0,0,0,1,.24,2,2,0,0,0,.53-.07,1.71,1.71,0,0,0,.48-.18,1.07,1.07,0,0,0,.35-.32.87.87,0,0,0-.21-1.15,3.21,3.21,0,0,0-.85-.43c-.34-.12-.7-.24-1.1-.36a5.16,5.16,0,0,1-1.1-.48,2.7,2.7,0,0,1-.85-.8,2.33,2.33,0,0,1-.33-1.31,3,3,0,0,1,.3-1.38,3.18,3.18,0,0,1,.83-1,3.92,3.92,0,0,1,1.19-.6,5,5,0,0,1,1.39-.2,5.35,5.35,0,0,1,1.6.24,3.62,3.62,0,0,1,1.39.78Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M872.62,1038.13h3.22a9.38,9.38,0,0,1,2.22.26,5.11,5.11,0,0,1,1.84.85,4.24,4.24,0,0,1,1.25,1.52,5.08,5.08,0,0,1,.46,2.27,4.5,4.5,0,0,1-1.65,3.61,5.75,5.75,0,0,1-1.75.93,6.85,6.85,0,0,1-2.08.31h-3.51Zm2.14,7.77h1.12a6,6,0,0,0,1.38-.15,2.84,2.84,0,0,0,1.11-.51,2.41,2.41,0,0,0,.74-.92,3.27,3.27,0,0,0,.27-1.4,2.7,2.7,0,0,0-.27-1.24,2.49,2.49,0,0,0-.72-.88,3.12,3.12,0,0,0-1.07-.51,4.57,4.57,0,0,0-1.29-.18h-1.27Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M827.84,992.11H759.57a2.54,2.54,0,0,1-2.53-2.53h0a2.54,2.54,0,0,1,2.53-2.53h68.27a2.53,2.53,0,0,1,2.52,2.53h0A2.53,2.53,0,0,1,827.84,992.11Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 749.94,
    y: 977.95,
    width: 48.04,
    height: 5.06,
    rx: 2.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M827.84,1062.23H759.57a2.54,2.54,0,0,1-2.53-2.53h0a2.54,2.54,0,0,1,2.53-2.53h68.27a2.53,2.53,0,0,1,2.52,2.53h0A2.53,2.53,0,0,1,827.84,1062.23Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 749.94,
    y: 1048.07,
    width: 48.04,
    height: 5.06,
    rx: 2.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M544.5,1099a2,2,0,0,1-1.37-.53,2,2,0,0,1-.13-2.86l7.42-8.09a2,2,0,0,1,1.49-.65h0a2,2,0,0,1,1.49.66l6.75,7.41a2,2,0,0,1-3,2.73l-5.26-5.78-5.91,6.46A2,2,0,0,1,544.5,1099Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M858,1214.27a2,2,0,0,1,.53-1.37,2,2,0,0,1,2.86-.13l8.09,7.41a2,2,0,0,1,.66,1.5h0a2,2,0,0,1-.66,1.49l-7.42,6.75a2,2,0,0,1-2.73-3l5.78-5.26-6.45-5.91A2,2,0,0,1,858,1214.27Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M851.6,1130a2,2,0,0,1,3.39-1.5l8.09,7.42a2,2,0,0,1,.66,1.49h0a2,2,0,0,1-.66,1.49l-7.41,6.75a2,2,0,0,1-2.73-3l5.78-5.26-6.46-5.91A2.05,2.05,0,0,1,851.6,1130Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M850.26,1110.1a2,2,0,0,1,3.39-1.49l8.09,7.41a2,2,0,0,1,.65,1.49h0a2,2,0,0,1-.66,1.49l-7.41,6.75a2,2,0,0,1-2.73-3l5.78-5.26-6.46-5.91A2,2,0,0,1,850.26,1110.1Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M631.47,1220.67a1,1,0,0,1-1-1V1089.2a1,1,0,0,1,2,0v130.46A1,1,0,0,1,631.47,1220.67Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M731.93,1220.67a1,1,0,0,1-1-1V1089.2a1,1,0,0,1,2,0v130.46A1,1,0,0,1,731.93,1220.67Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M839.13,1220.67a1,1,0,0,1-1-1V1089.2a1,1,0,0,1,2,0v130.46A1,1,0,0,1,839.13,1220.67Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M552.25,1222.69a1.91,1.91,0,0,1-.74-.14,2,2,0,0,1-1.14-2.63c1.66-4.2,41-103.09,78.74-103.09,12.53,0,23.78,14.88,36.81,32.11,16.63,22,35.5,47,61.29,47,22.37,0,41.4-18.86,61.55-38.83,20.64-20.43,42-41.57,67.9-41.57a2,2,0,0,1,0,4c-24.27,0-45,20.54-65,40.4-19.84,19.66-40.36,40-64.4,40-27.81,0-47.31-25.81-64.52-48.56-12.38-16.36-23.05-30.5-33.58-30.5-35,0-74.59,99.52-75,100.54A2,2,0,0,1,552.25,1222.69Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M552.75,1223.7a2,2,0,0,1-1.07-.31,2,2,0,0,1-.64-2.79c1.44-2.28,35.65-55.89,78.74-55.89,19.68,0,31.46,10.07,43.93,20.73,15.32,13.1,31.17,26.64,64.15,24.45,16.7-1.11,34.26-17.4,52.86-34.64C812,1155.48,834.07,1135,857.67,1135a2,2,0,0,1,0,4c-22,0-43.46,19.89-64.2,39.12-19.14,17.75-37.21,34.51-55.34,35.71-34.63,2.31-51.86-12.42-67-25.4-11.89-10.17-23.12-19.77-41.3-19.77-40.88,0-75,53.47-75.31,54A2,2,0,0,1,552.75,1223.7Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M551.57,1237.53a2,2,0,0,1-2-2V1093.92a2,2,0,1,1,4.05,0V1235.5A2,2,0,0,1,551.57,1237.53Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M865.09,1223.37H537.42a2,2,0,1,1,0-4H865.09a2,2,0,0,1,0,4Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "379.6 953.14 385.87 989.41 361.42 989.34 360.82 957.6 379.6 953.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M390.23,1006.81s22.15,2.64,43.19,12.57c0,0-6,43.88-11.76,84l-.73,46.43-77.86-.25,2-45.3-16.48-86s27.73-9.88,36.45-10.38S390.23,1006.81,390.23,1006.81Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "357.91 986.36 361.06 982.05 375.37 985.66 385.11 981.38 390.62 986.83 374.6 990.66 358.6 988.74 357.91 986.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "377.38 987.62 382.34 991.42 380.19 998.56 375.23 999.01 370.68 991.95 377.38 987.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M410.17,1422.09s.33-14.55,1.58-44l-17.7-3.06s-1.61,47.82-2.06,50.26,6.78,6.42,6.78,6.42l8.55-3.17Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M431.4,1436c-13.07-3.06-21.31-15.8-21.31-15.8-10.45,11.82-17.9,3-17.9,3-4.76,13.18-2.71,23.39-2.71,23.39s3.95.42,11.59.88l0-3s5.25-.17,13.09,3.61c2.4.09,4.95.17,7.68.24,21.22.55,24.89-1.49,25.58-3.34S444.46,1439,431.4,1436Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M337.91,1422.69s0-10.78,9.23-44.64l-20.8-2.08s-6.15,47.45-6.61,49.88,6.79,6.42,6.79,6.42l8.54-3.16Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M359.14,1436.58c-13.06-3.06-21.31-15.81-21.31-15.81-10.45,11.82-17.89,3-17.89,3-4.77,13.19-2.72,23.4-2.72,23.4s4,.42,11.59.88l0-3s5.25-.17,13.1,3.62q3.58.13,7.68.24c21.22.54,24.88-1.49,25.58-3.35S372.21,1439.63,359.14,1436.58Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "418.75 1115.73 410.15 1395.59 380.83 1395.59 369.35 1195.74 342.9 1395.88 309.62 1395.59 326.06 1121.07 418.75 1115.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M367.92,981s2.75,20.65,22.87,18.18l-1.12-7.94Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M365.47,1007.25l.23,104-32.34,73.38s-2.57-.4-13.27-7.53l12.78-63-7.43-97.45S353,1010.22,365.47,1007.25Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M397.19,1007.7l5.94,101.63,22.92,72.54s1.79-3.17,16.64-7.93l-16.83-60.4,9.5-96.26A167.08,167.08,0,0,0,397.19,1007.7Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "380.19 998.56 388.15 1100.87 379.54 1113.65 369.74 1101.47 375.68 998.08 380.19 998.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M365.7,1111l-.23-103.71-13.64,3.23,9.26,39.87-6.24,8.62Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M397.19,1007.7s8.46,1.26,13.42,2.45l-4.06,43,5.14,4.75-8.61,51.15Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M400.4,962.41s2.93-2.88,4.85-1.26,2.21,8.1-3.91,9.38A15.87,15.87,0,0,1,400.4,962.41Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 46,
    height: 59,
    transform: "translate(349.9 914.42)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAA7CAYAAAAEorgfAAAACXBIWXMAAAsSAAALEgHS3X78AAABTUlEQVRoQ+2aORLCMBAEx36Hn0lMQMwz+YeJRC1Gx0qW5RkXnfpQb9cmHNO6rujF6/lIvmy53afUtRamVvGcpIe9g7jF94rmaBnCJX6ktKVmgKz4KGGLV35OXThDGvCfGxX3PnwUnvN/xD0PjaDkkVwVBnLyX+KlKc8g5fQRZ5TOQb0qgVhUCfEYM6CxJltH7eIq2OpS4pZZYb9j6BYv3cCKnHhYbTnxwF98NLri3g+nbOgWL93AiqT46/lYZ8D/JQwTksUBI65WXb+4Gl/iSutyjeKATvVocXb55XafrrMqAfbq2eLM8tdblQBr9aI4Ky5xpurBxSXOiFucqTpQIQ5wyVeJAzzy1eIsNImfVd2e2yQOjJffntcsDoyXt+wSB8bIx87YLQ6Mkd/i+k9WDb1/xUtF6VLc0rN+7l3di1ta63uGP1Q8RmwYj+iWN7+khM/hUR9fAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M396.8,948.25s3.88,8.7,5.34,13.45c0,0-.89-13.61-3.47-16.87S396.8,948.25,396.8,948.25Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M376.87,968.83c-.42-1.89-.15-3.55.61-3.72s1.7,1.23,2.12,3.11.14,3.55-.61,3.72S377.28,970.71,376.87,968.83Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M393.34,965.88c-.39-1.89-.1-3.55.66-3.7s1.69,1.25,2.08,3.14.09,3.55-.67,3.7S393.73,967.77,393.34,965.88Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M392.62,942.87h0C392.63,942.8,392.63,942.82,392.62,942.87Z",
    transform: "translate(-7.1 -21.58)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M388.73,976.85a.17.17,0,0,1-.16-.05,1,1,0,0,1-.27-1.18c.09-.28.38-.37.61-.44l.19-.07.2-.09a3.61,3.61,0,0,0,1-.53,1.06,1.06,0,0,0,.4-1,1.66,1.66,0,0,0-.34-.52l0,0a10.82,10.82,0,0,1-2.48-6,.17.17,0,0,1,.17-.19.18.18,0,0,1,.2.16,10.44,10.44,0,0,0,2.38,5.83l0,0a1.89,1.89,0,0,1,.41.65,1.41,1.41,0,0,1-.52,1.43,3.93,3.93,0,0,1-1.08.59l-.2.08-.22.08c-.17.05-.34.11-.37.21a.65.65,0,0,0,.17.81.19.19,0,0,1,0,.26Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M393.74,935c-5.74-.22-11.33-2.58-17.06-2.13-7.56.58-13.84,5.87-19.36,11.11a6.31,6.31,0,0,1-.63-3.72,6,6,0,0,0-1.34,5.37,5.32,5.32,0,0,1-2.16-.4,9.83,9.83,0,0,0,2.45,2.45c-1.47,1.47-1.61,3.8-1.4,5.87.73,7,4.39,13.27,8,19.3l3.24-.61,1-18.71c9.62-3.54,19.84-7.14,29.88-5.1a2.36,2.36,0,0,0,1.7-.06,2.2,2.2,0,0,0,.8-1.1,26.6,26.6,0,0,0,2-13.48,14.46,14.46,0,0,1-1.88,5.38l-.16-6.37C398,934.66,395.69,935.11,393.74,935Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M367.34,972.56s-1.18-6.52-7.34-2.72c-2.44,1.51-1,8.87,6.64,8.39C366.64,978.23,369.09,977.08,367.34,972.56Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M390.67,958.29c.68.48,1.89,0,2.66,0,1.79.05,2.88,1.45,4.53,1.77a.54.54,0,0,0,.63-.67c-.5-2.79-6.84-4.92-8.06-1.63a.51.51,0,0,0,.24.55Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M380.5,959.91c-.55.63-1.84.41-2.59.61-1.72.48-2.45,2.1-4,2.8a.54.54,0,0,1-.77-.5c-.18-2.83,5.48-6.41,7.44-3.5a.5.5,0,0,1-.1.59Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M395.67,979,383,980.72S391,991.32,395.67,979Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M326.23,1139.31l16.06,13.55s9.14,14,7.85,15.68-13.52,10.81-13.52,10.81a45.12,45.12,0,0,1-12.22-23.43c-.22-1.22-9.25-7.65-9.25-7.65Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M344.54,1165.79l6.14,10.34a2.37,2.37,0,0,0,3.23.82h0a2.37,2.37,0,0,0,.82-3.23l-6.13-10.33a2.35,2.35,0,0,0-3.23-.82h0A2.35,2.35,0,0,0,344.54,1165.79Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M339.47,1166.48l6.91,11.65a2.37,2.37,0,0,0,3.23.82h0a2.36,2.36,0,0,0,.83-3.23l-6.92-11.65a2.37,2.37,0,0,0-3.23-.82h0A2.37,2.37,0,0,0,339.47,1166.48Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M334.52,1167.36l7.75,13.07a2.37,2.37,0,0,0,3.23.82h0a2.35,2.35,0,0,0,.82-3.23L338.57,1165a2.36,2.36,0,0,0-3.23-.83h0A2.37,2.37,0,0,0,334.52,1167.36Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 330.07,
    y: 1173.38,
    width: 13.9,
    height: 4.71,
    rx: 1.97,
    transform: "translate(1168.95 264.23) rotate(59.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M336.64,1148.54a66.4,66.4,0,0,1,14.26,7.79c3,2.11,8.24,10.74,7.75,11.19-1.78,1.66-4.17-.72-9.77-6.94-.08-.1-7.39.82-9.26.44-6.41-1.32-2.19-1.39-6.4-4.58l-1.62-1.23Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "326.72 1122.59 331.35 1126.99 317.58 1141.56 312.03 1135.11 326.72 1122.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M325.44,1016.68c-12.78,2.18-46.94,82.4-46.35,89.53s29.71,49.31,42.78,56.74L337.62,1146l-26.74-40.7s19.61-28.82,19.61-30S325.44,1016.68,325.44,1016.68Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M335.54,1181.07s13.82-16.48,13.82-18.71,8,12.48,8,12.48l-2.83,13.51L339.11,1190Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M434.33,1140.1l-16.05,13.55s-9.14,14-7.85,15.68S424,1180.14,424,1180.14a45.12,45.12,0,0,0,12.22-23.43c.22-1.22,9.25-7.65,9.25-7.65Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M416,1166.59l-6.13,10.33a2.37,2.37,0,0,1-3.23.82h0a2.37,2.37,0,0,1-.82-3.23l6.13-10.33a2.37,2.37,0,0,1,3.23-.82h0A2.35,2.35,0,0,1,416,1166.59Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M421.1,1167.27l-6.92,11.65a2.36,2.36,0,0,1-3.22.82h0a2.36,2.36,0,0,1-.83-3.23l6.92-11.65a2.37,2.37,0,0,1,3.23-.82h0A2.37,2.37,0,0,1,421.1,1167.27Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M426.05,1168.15l-7.75,13.07a2.37,2.37,0,0,1-3.23.83h0a2.37,2.37,0,0,1-.83-3.23l7.76-13.07a2.36,2.36,0,0,1,3.23-.82h0A2.36,2.36,0,0,1,426.05,1168.15Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 416.6,
    y: 1174.17,
    width: 13.9,
    height: 4.71,
    rx: 1.97,
    transform: "matrix(-0.51, 0.86, -0.86, -0.51, 1644.36, 1391.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M423.93,1149.34a66.59,66.59,0,0,0-14.26,7.78c-3,2.11-8.24,10.74-7.76,11.19,1.79,1.66,4.18-.72,9.77-6.94.09-.1,7.4.82,9.27.44,6.41-1.32,2.19-1.39,6.4-4.58L429,1156Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "419.65 1123.39 415.02 1127.78 428.78 1142.36 434.34 1135.9 419.65 1123.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M435.13,1017.48c12.77,2.17,46.94,82.39,46.35,89.52s-29.71,49.32-42.79,56.74L423,1146.81l26.74-40.7s-20.12-28.72-20.12-29.91S435.13,1017.48,435.13,1017.48Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M424.22,1181.52s-13-16.14-13-18.37-8,12.48-8,12.48l2.82,13.51,15.45,1.64Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "1150.13 697.29 1156.31 733.04 1132.21 732.97 1131.62 701.68 1150.13 697.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1160.71,750.5s21.84,2.6,42.58,12.39c0,0-5.87,43.27-11.59,82.84l-.72,45.78-76.77-.25,2-44.67-16.25-84.75s27.34-9.74,35.94-10.23S1160.71,750.5,1160.71,750.5Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1128.74 730.03 1131.85 725.78 1145.96 729.35 1155.57 725.13 1161 730.49 1145.2 734.28 1129.43 732.38 1128.74 730.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "1147.95 731.27 1152.83 735.02 1150.72 742.06 1145.83 742.5 1141.33 735.54 1147.95 731.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1191.11,1159.34s-1.14-17-.36-59.53l-21.48,6.64s4.36,53.61,3.91,56,6.7,6.33,6.7,6.33l8.42-3.12Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1212,1173c-12.88-3-21-15.59-21-15.59-10.3,11.66-17.64,3-17.64,3-4.7,13-2.68,23.07-2.68,23.07s3.9.41,11.43.86l0-2.95s5.18-.17,12.92,3.57q3.54.12,7.57.23c20.92.54,24.54-1.46,25.22-3.3S1224.92,1176.05,1212,1173Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1103,1159.34s1.14-17,.36-59.53l21.48,6.64s-4.36,53.61-3.91,56-6.7,6.33-6.7,6.33l-8.42-3.12Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1082,1173c12.88-3,21-15.59,21-15.59,10.3,11.66,17.64,3,17.64,3,4.7,13,2.68,23.07,2.68,23.07s-3.9.41-11.43.86l0-2.95s-5.18-.17-12.91,3.57q-3.54.12-7.57.23c-20.92.54-24.54-1.46-25.22-3.3S1069.14,1176.05,1082,1173Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1184.83 858.75 1187.36 878.86 1186.97 1128.81 1161.19 1128.81 1146.55 926.7 1117.26 1127.05 1090.31 1127.63 1105.35 875.93 1107.02 856.11 1184.83 858.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1138.72,725.09s2.71,20.35,22.55,17.91l-1.11-7.83Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1150.72 742.06 1158.57 842.93 1150.07 855.53 1140.41 843.52 1146.26 741.59 1150.72 742.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "1105.93 864.41 1186.19 866.56 1185.41 857.77 1106.71 855.43 1105.93 864.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1137.37,
    y: 855.82,
    width: 21.48,
    height: 10.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1170.74,706.73s2.89-2.84,4.78-1.25,2.17,8-3.85,9.25A15.62,15.62,0,0,1,1170.74,706.73Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 45,
    height: 58,
    transform: "translate(1120.9 659.42)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAA6CAYAAAAkydC5AAAACXBIWXMAAAsSAAALEgHS3X78AAABOElEQVRoQ+2a0Y6DIBAAB7/zeh/X639yT1yoh7AgbncN81grO0yMMcYQY+QsP99f4kUez1do/adFGJHukawxugGx9CzREr3yTekrZfdI5bfaQU1hkM87lJYuMBvJ3KK05MQrac3/J906QYuax5u0FeHEkc+ftDXhGtW7hwVKMc1Ll3Ahva+9lX60jovS8B7WjXTO5u3SAGelU2BX0oklrcWS1mJJaxFijOvZQ4MlrcUG8jc7VvBbGnzV9l0a/NT2Xxp81L5HabBf+7C0VfHH8xXuc3kkrNa+X2mwWbspDfbERdLWEEtbqi2WtkAK1yVtpXaXNNgQ75aGz4jnM4ek4TPiiWFp0BPfzzklDXriOael4Vrx0trNz4F6mfky8yjGlNI5s6rX1pleOmekumTTl0qXyDciESzxC5YLhi3OMOBKAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1167.19,692.77s3.83,8.58,5.26,13.25c0,0-.88-13.42-3.42-16.62S1167.19,692.77,1167.19,692.77Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1147.54,713.05c-.41-1.85-.14-3.5.6-3.66s1.68,1.21,2.09,3.06.14,3.5-.6,3.67S1148,714.91,1147.54,713.05Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1163.78,710.15c-.39-1.86-.1-3.5.65-3.65s1.66,1.23,2,3.09.09,3.5-.66,3.65S1164.16,712,1163.78,710.15Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1163.07,687.46h0C1163.08,687.39,1163.08,687.41,1163.07,687.46Z",
    transform: "translate(-7.1 -21.58)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1159.88,720.18a.36.36,0,0,1-.29,0,.87.87,0,0,1-.48-1.07.34.34,0,0,1,.23-.2,9.34,9.34,0,0,0,2-.88c.47-.31,1-.81.9-1.29s-.39-.64-.75-.93l-.16-.13c-2.19-1.8-2.65-4.57-3-6.79,0-.13.12-.27.28-.3s.34,0,.36.15c.38,2.28.8,4.87,2.89,6.6l.16.12a2,2,0,0,1,.87,1.14,2.1,2.1,0,0,1-1.17,1.75,9,9,0,0,1-2,.9.58.58,0,0,0,.33.54c.13.06.13.21,0,.32A.56.56,0,0,1,1159.88,720.18Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1137.26,716.88l2.53-22.84-12.1,2.54s0,12.49,4.49,19.13Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1138.15,716.73s-1.17-6.42-7.24-2.68c-2.41,1.49-1,8.75,6.55,8.27C1137.46,722.32,1139.87,721.19,1138.15,716.73Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1126.08,695.37a3.27,3.27,0,0,1,1.32-5.35,2.62,2.62,0,0,1,2.9-3.52,3.09,3.09,0,0,1,3.22-4.16,4.38,4.38,0,0,1,1.27-3,2.42,2.42,0,0,1,3-.21,4.46,4.46,0,0,1,6.44-1.49,3.07,3.07,0,0,1,5.64-.75,3.44,3.44,0,0,1,4.39-1,3.3,3.3,0,0,0,1.1.57,3.44,3.44,0,0,0,1.34-.2,3.6,3.6,0,0,1,3.8,1.68,2.94,2.94,0,0,1,4.67.75,2.78,2.78,0,0,1,4.74,2.12,8.26,8.26,0,0,1,.41,9.23,1.94,1.94,0,0,1-3.19,1.5,2.36,2.36,0,0,1-3.91.45,3.49,3.49,0,0,1-3.21,1.35,4.63,4.63,0,0,0-1.87-.18c-.61.16-1,.71-1.55,1.06a2.76,2.76,0,0,1-3.44-.39,3.93,3.93,0,0,1-5.39.62,3.14,3.14,0,0,1-4.92.57,3.78,3.78,0,0,1-5.57,1.3,3.07,3.07,0,0,1-4.26,2.48c-.68-.35-1.37-1-2.09-.71a2.73,2.73,0,0,0-.83.69,2.68,2.68,0,0,1-4-3.49Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1160.69,702.23c1.31-.22,2.51-.69,3.78-1a33.7,33.7,0,0,1,3.73-.49.54.54,0,0,0,.24-.9c-2.39-1.85-5.73-.31-8.33.3-1.4.32-.79,2.35.58,2.11Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1149.85,701c-3.07.59-7.68.86-8.84,4.37a.39.39,0,0,0,.41.47,14.88,14.88,0,0,0,3.68-1.11,34.57,34.57,0,0,1,5.25-1.14,1.32,1.32,0,1,0-.5-2.59Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1153.69,722.85c-2.17.4-2.47,2.43-1.64,4.2,1.38,3,5.32,3.73,8.26,3.32s6.31-2.16,7-5.3a2,2,0,0,0-2.21-2.62,32.47,32.47,0,0,0-4.08.84,11.19,11.19,0,0,1-3.91-.18A9.77,9.77,0,0,0,1153.69,722.85Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1079.7,851.74,1099.35,865s16.84,6.34,16.45,8.39-5.73,17.08-5.73,17.08-8.43-2.78-19.53-12.41c-.91-.79-17.57-13.46-17.57-13.46Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1089.55,864.41s11.67-1.17,21,.21c3.56.52,12.77,7.81,12.32,10.15s-11.65-5.73-11.9-5a2.4,2.4,0,0,1-.78.86c-4.36,2.75-8,2.32-13.1,1.37l-1.95-.36Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1111.07,875.21l9.86,6.34a2.32,2.32,0,0,0,3.18-.69h0a2.31,2.31,0,0,0-.7-3.18l-9.86-6.34a2.3,2.3,0,0,0-3.17.69h0A2.3,2.3,0,0,0,1111.07,875.21Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1106.94,878l11.12,7.15a2.3,2.3,0,0,0,3.17-.69h0a2.3,2.3,0,0,0-.69-3.18l-11.12-7.15a2.3,2.3,0,0,0-3.17.7h0A2.3,2.3,0,0,0,1106.94,878Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1103,881l12.48,8a2.3,2.3,0,0,0,3.17-.69h0a2.31,2.31,0,0,0-.69-3.18l-12.47-8a2.32,2.32,0,0,0-3.18.69h0A2.32,2.32,0,0,0,1103,881Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 1102.07,
    y: 884.87,
    width: 13.56,
    height: 4.6,
    rx: 1.92,
    transform: "translate(648.52 -480.21) rotate(32.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1087.91,877.81s-58.29-36.32-54.78-51.84,60-66.79,70.19-64.64,8.4,38.67,8.4,38.67l-44,25.38,29.88,38.08Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1267.17,813.08l9.37,12.89s-55.3,42.49-69.12,16.4c-20.7-39-21.59-45.5-19.63-49s15.5-30.47,15.5-30.47l22.09,57.22Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "1317.89 737.99 1223.32 739.25 1211.14 808.36 1305.07 808.03 1317.89 737.99"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1183.75,
    y: 824,
    width: 60.25,
    height: 5.98,
    transform: "translate(-18.02 -5.32) rotate(-0.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1286.67,790.12a8.12,8.12,0,1,0-8,8.23A8.12,8.12,0,0,0,1286.67,790.12Z",
    transform: "translate(-7.1 -21.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 1278.97,
    y: 822.69,
    width: 15.82,
    height: 4.69,
    rx: 2.29,
    transform: "matrix(0.21, 0.98, -0.98, 0.21, 1811.89, -629.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 1273.42,
    y: 822.55,
    width: 17.27,
    height: 4.69,
    rx: 2.29,
    transform: "translate(1807.94 -624.98) rotate(77.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 1267.86,
    y: 822.68,
    width: 18.83,
    height: 4.69,
    rx: 2.29,
    transform: "matrix(0.21, 0.98, -0.98, 0.21, 1804.3, -620.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 1266.53,
    y: 824.44,
    width: 13.14,
    height: 4.69,
    rx: 1.91,
    transform: "translate(1802.75 -614.75) rotate(77.71)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.44d3a763d946a2666a350eadd6efe4c0.svg";
export { ForwardRef as ReactComponent };